// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/contract_model.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { ReviewItem } from "../../common/v1/types_pb";
/**
 * OccurrenceWindow is ListOccurrences' window filter (D104).
 *
 * @generated from enum mono.datagateway.v1.OccurrenceWindow
 */ export var OccurrenceWindow = /*#__PURE__*/ function(OccurrenceWindow) {
    /**
   * @generated from enum value: OCCURRENCE_WINDOW_UNSPECIFIED = 0;
   */ OccurrenceWindow[OccurrenceWindow["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * Every row.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_ALL = 1;
   */ OccurrenceWindow[OccurrenceWindow["ALL"] = 1] = "ALL";
    /**
   * The contract period (Base, OPn) containing as_of, plus open rows
   * carried over from before it.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_CONTRACT_CURRENT_PERIOD = 2;
   */ OccurrenceWindow[OccurrenceWindow["CONTRACT_CURRENT_PERIOD"] = 2] = "CONTRACT_CURRENT_PERIOD";
    /**
   * workstream_id's own current window: the in-force SOW's interval
   * containing as_of, else its exercise line's window; plus its open rows
   * carried over from before it.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_WORKSTREAM_CURRENT_WINDOW = 3;
   */ OccurrenceWindow[OccurrenceWindow["WORKSTREAM_CURRENT_WINDOW"] = 3] = "WORKSTREAM_CURRENT_WINDOW";
    /**
   * period_of_performance_id's span (a past period on the D104 picker),
   * plus open rows carried over from before it. Status is still computed on
   * as_of.
   *
   * @generated from enum value: OCCURRENCE_WINDOW_CONTRACT_PERIOD = 4;
   */ OccurrenceWindow[OccurrenceWindow["CONTRACT_PERIOD"] = 4] = "CONTRACT_PERIOD";
    return OccurrenceWindow;
}({});
// Retrieve enum metadata with: proto3.getEnumType(OccurrenceWindow)
proto3.util.setEnumType(OccurrenceWindow, "mono.datagateway.v1.OccurrenceWindow", [
    {
        no: 0,
        name: "OCCURRENCE_WINDOW_UNSPECIFIED"
    },
    {
        no: 1,
        name: "OCCURRENCE_WINDOW_ALL"
    },
    {
        no: 2,
        name: "OCCURRENCE_WINDOW_CONTRACT_CURRENT_PERIOD"
    },
    {
        no: 3,
        name: "OCCURRENCE_WINDOW_WORKSTREAM_CURRENT_WINDOW"
    },
    {
        no: 4,
        name: "OCCURRENCE_WINDOW_CONTRACT_PERIOD"
    }
]);
/**
 * SowGapChoice is the answer to a SOW_HISTORY_MISSING item (D104).
 *
 * @generated from enum mono.datagateway.v1.SowGapChoice
 */ export var SowGapChoice = /*#__PURE__*/ function(SowGapChoice) {
    /**
   * @generated from enum value: SOW_GAP_CHOICE_UNSPECIFIED = 0;
   */ SowGapChoice[SowGapChoice["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * "Latest SOW applied all along": sow_id is the later SOW.
   *
   * @generated from enum value: SOW_GAP_CHOICE_LATEST_SOW = 1;
   */ SowGapChoice[SowGapChoice["LATEST_SOW"] = 1] = "LATEST_SOW";
    /**
   * "Award schedule applied".
   *
   * @generated from enum value: SOW_GAP_CHOICE_AWARD = 2;
   */ SowGapChoice[SowGapChoice["AWARD"] = 2] = "AWARD";
    /**
   * "Upload the earlier version": an action, not a ruling. Nothing is stored;
   * the gap stays open until CreateSow adds the version.
   *
   * @generated from enum value: SOW_GAP_CHOICE_UPLOAD_EARLIER = 3;
   */ SowGapChoice[SowGapChoice["UPLOAD_EARLIER"] = 3] = "UPLOAD_EARLIER";
    return SowGapChoice;
}({});
// Retrieve enum metadata with: proto3.getEnumType(SowGapChoice)
proto3.util.setEnumType(SowGapChoice, "mono.datagateway.v1.SowGapChoice", [
    {
        no: 0,
        name: "SOW_GAP_CHOICE_UNSPECIFIED"
    },
    {
        no: 1,
        name: "SOW_GAP_CHOICE_LATEST_SOW"
    },
    {
        no: 2,
        name: "SOW_GAP_CHOICE_AWARD"
    },
    {
        no: 3,
        name: "SOW_GAP_CHOICE_UPLOAD_EARLIER"
    }
]);
/**
 * WriteContext is which audit correlation a write joins. Who is writing is
 * never in the message: the tenant and the actor are the gateway principal's
 * (X-Tenant-ID / X-User-ID, forwarded by the caller; R8).
 *
 * @generated from message mono.datagateway.v1.WriteContext
 */ export class WriteContext extends Message {
    static fromBinary(bytes, options) {
        return new WriteContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteContext, a, b);
    }
    constructor(data){
        super(), /**
   * correlation_id groups this write's audit event with others; "" mints one.
   *
   * @generated from field: string correlation_id = 2;
   */ _define_property(this, "correlationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteContext, "runtime", proto3);
_define_property(WriteContext, "typeName", "mono.datagateway.v1.WriteContext");
_define_property(WriteContext, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "correlation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * MintCounts is what the verb's Mint wrote.
 *
 * @generated from message mono.datagateway.v1.MintCounts
 */ export class MintCounts extends Message {
    static fromBinary(bytes, options) {
        return new MintCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MintCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MintCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MintCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 inserted = 1;
   */ _define_property(this, "inserted", 0), /**
   * @generated from field: int32 updated = 2;
   */ _define_property(this, "updated", 0), /**
   * @generated from field: int32 retired = 3;
   */ _define_property(this, "retired", 0), /**
   * @generated from field: int32 revived = 4;
   */ _define_property(this, "revived", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MintCounts, "runtime", proto3);
_define_property(MintCounts, "typeName", "mono.datagateway.v1.MintCounts");
_define_property(MintCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "inserted",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "updated",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "retired",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "revived",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * WriteResult is on every write response.
 *
 * @generated from message mono.datagateway.v1.WriteResult
 */ export class WriteResult extends Message {
    static fromBinary(bytes, options) {
        return new WriteResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WriteResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WriteResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WriteResult, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.MintCounts mint = 1;
   */ _define_property(this, "mint", void 0), /**
   * @generated from field: string audit_event_id = 2;
   */ _define_property(this, "auditEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WriteResult, "runtime", proto3);
_define_property(WriteResult, "typeName", "mono.datagateway.v1.WriteResult");
_define_property(WriteResult, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "mint",
            kind: "message",
            T: MintCounts
        },
        {
            no: 2,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractDuty
 */ export class ContractDuty extends Message {
    static fromBinary(bytes, options) {
        return new ContractDuty().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractDuty().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractDuty().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractDuty, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string duty_key = 3;
   */ _define_property(this, "dutyKey", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string pws_ref = 5;
   */ _define_property(this, "pwsRef", ""), /**
   * @generated from field: string letter = 6;
   */ _define_property(this, "letter", ""), /**
   * @generated from field: repeated string aliases = 7;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string description = 8;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string format = 9;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 10;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 11;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: string final_review_tier = 12;
   */ _define_property(this, "finalReviewTier", ""), /**
   * @generated from field: string origin = 13;
   */ _define_property(this, "origin", ""), /**
   * @generated from field: string sow_id = 14;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string source_document_id = 15;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 16;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string introduced_by_modification_id = 17;
   */ _define_property(this, "introducedByModificationId", ""), /**
   * @generated from field: string ended_by_modification_id = 18;
   */ _define_property(this, "endedByModificationId", ""), /**
   * @generated from field: string ended_on = 19;
   */ _define_property(this, "endedOn", ""), /**
   * event_kind is the event this duty dates ("" = none): logging that event
   * meets its date, and the event's dependents are projected from it until
   * then (S6).
   *
   * @generated from field: string event_kind = 20;
   */ _define_property(this, "eventKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractDuty, "runtime", proto3);
_define_property(ContractDuty, "typeName", "mono.datagateway.v1.ContractDuty");
_define_property(ContractDuty, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "letter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "final_review_tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "introduced_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "ended_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "ended_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractScheduleRule
 */ export class ContractScheduleRule extends Message {
    static fromBinary(bytes, options) {
        return new ContractScheduleRule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractScheduleRule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractScheduleRule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractScheduleRule, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string duty_id = 2;
   */ _define_property(this, "dutyId", ""), /**
   * assignment_id is set on a team rule (gate "sow").
   *
   * @generated from field: string assignment_id = 3;
   */ _define_property(this, "assignmentId", ""), /**
   * @generated from field: string clin_id = 4;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string gate = 5;
   */ _define_property(this, "gate", ""), /**
   * @generated from field: string period_of_performance_id = 6;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string optional_task_id = 7;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string kind = 8;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string due_on = 9;
   */ _define_property(this, "dueOn", ""), /**
   * offset_n is signed; has_offset distinguishes 0 from unset.
   *
   * @generated from field: bool has_offset = 10;
   */ _define_property(this, "hasOffset", false), /**
   * @generated from field: int32 offset_n = 11;
   */ _define_property(this, "offsetN", 0), /**
   * @generated from field: string offset_unit = 12;
   */ _define_property(this, "offsetUnit", ""), /**
   * @generated from field: string cadence = 13;
   */ _define_property(this, "cadence", ""), /**
   * @generated from field: int32 cadence_interval = 14;
   */ _define_property(this, "cadenceInterval", 0), /**
   * @generated from field: repeated int32 day_ordinals = 15;
   */ _define_property(this, "dayOrdinals", []), /**
   * @generated from field: string day_weekday = 16;
   */ _define_property(this, "dayWeekday", ""), /**
   * @generated from field: string day_basis = 17;
   */ _define_property(this, "dayBasis", ""), /**
   * @generated from field: string event_kind = 18;
   */ _define_property(this, "eventKind", ""), /**
   * @generated from field: repeated string subjects = 19;
   */ _define_property(this, "subjects", []), /**
   * @generated from field: string rule_text = 20;
   */ _define_property(this, "ruleText", ""), /**
   * @generated from field: string source_document_id = 21;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 22;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string effective_from = 23;
   */ _define_property(this, "effectiveFrom", ""), /**
   * @generated from field: string effective_to = 24;
   */ _define_property(this, "effectiveTo", ""), /**
   * @generated from field: string established_by_modification_id = 25;
   */ _define_property(this, "establishedByModificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractScheduleRule, "runtime", proto3);
_define_property(ContractScheduleRule, "typeName", "mono.datagateway.v1.ContractScheduleRule");
_define_property(ContractScheduleRule, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "assignment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "gate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "has_offset",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "offset_n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "offset_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "cadence_interval",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "day_ordinals",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 16,
            name: "day_weekday",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "day_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "subjects",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 20,
            name: "rule_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 23,
            name: "effective_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 24,
            name: "effective_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 25,
            name: "established_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.OverrideLocator
 */ export class OverrideLocator extends Message {
    static fromBinary(bytes, options) {
        return new OverrideLocator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OverrideLocator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OverrideLocator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OverrideLocator, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string field = 1;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string source_locator = 2;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string quote = 3;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OverrideLocator, "runtime", proto3);
_define_property(OverrideLocator, "typeName", "mono.datagateway.v1.OverrideLocator");
_define_property(OverrideLocator, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractDutyAssignment
 */ export class ContractDutyAssignment extends Message {
    static fromBinary(bytes, options) {
        return new ContractDutyAssignment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractDutyAssignment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractDutyAssignment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractDutyAssignment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string sow_id = 2;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string duty_id = 3;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string handling = 4;
   */ _define_property(this, "handling", ""), /**
   * @generated from field: string routed_to_workstream_id = 5;
   */ _define_property(this, "routedToWorkstreamId", ""), /**
   * @generated from field: string not_owed_reason = 6;
   */ _define_property(this, "notOwedReason", ""), /**
   * Overrides; "" inherits the duty's term.
   *
   * @generated from field: string title_as_stated = 7;
   */ _define_property(this, "titleAsStated", ""), /**
   * @generated from field: string sender_contact_id = 8;
   */ _define_property(this, "senderContactId", ""), /**
   * @generated from field: string recipient = 9;
   */ _define_property(this, "recipient", ""), /**
   * @generated from field: string format = 10;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 11;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 12;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * @generated from field: repeated mono.datagateway.v1.OverrideLocator override_locators = 13;
   */ _define_property(this, "overrideLocators", []), /**
   * @generated from field: string source_locator = 14;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string note = 15;
   */ _define_property(this, "note", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ContractScheduleRule team_rules = 16;
   */ _define_property(this, "teamRules", []), /**
   * effective_terms reads the overrides over the award's terms.
   *
   * @generated from field: repeated mono.datagateway.v1.EffectiveTerm effective_terms = 17;
   */ _define_property(this, "effectiveTerms", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractDutyAssignment, "runtime", proto3);
_define_property(ContractDutyAssignment, "typeName", "mono.datagateway.v1.ContractDutyAssignment");
_define_property(ContractDutyAssignment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "handling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "routed_to_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "not_owed_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title_as_stated",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "sender_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "recipient",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "override_locators",
            kind: "message",
            T: OverrideLocator,
            repeated: true
        },
        {
            no: 14,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "team_rules",
            kind: "message",
            T: ContractScheduleRule,
            repeated: true
        },
        {
            no: 17,
            name: "effective_terms",
            kind: "message",
            T: EffectiveTerm,
            repeated: true
        }
    ]));
/**
 * EffectiveTerm is one field of a duty under an assignment. stated is false
 * when neither the SOW nor the award says anything.
 *
 * @generated from message mono.datagateway.v1.EffectiveTerm
 */ export class EffectiveTerm extends Message {
    static fromBinary(bytes, options) {
        return new EffectiveTerm().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EffectiveTerm().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EffectiveTerm().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EffectiveTerm, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string field = 1;
   */ _define_property(this, "field", ""), /**
   * @generated from field: string value = 2;
   */ _define_property(this, "value", ""), /**
   * @generated from field: bool stated = 3;
   */ _define_property(this, "stated", false), /**
   * @generated from field: bool from_sow = 4;
   */ _define_property(this, "fromSow", false), /**
   * @generated from field: string source_locator = 5;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string quote = 6;
   */ _define_property(this, "quote", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EffectiveTerm, "runtime", proto3);
_define_property(EffectiveTerm, "typeName", "mono.datagateway.v1.EffectiveTerm");
_define_property(EffectiveTerm, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "stated",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "from_sow",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractOccurrence
 */ export class ContractOccurrence extends Message {
    static fromBinary(bytes, options) {
        return new ContractOccurrence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractOccurrence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractOccurrence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractOccurrence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string duty_id = 2;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string rule_id = 3;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string exercise_id = 5;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string period_of_performance_id = 6;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string event_id = 7;
   */ _define_property(this, "eventId", ""), /**
   * @generated from field: string period_key = 8;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string label = 9;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string nominal_due_on = 10;
   */ _define_property(this, "nominalDueOn", ""), /**
   * @generated from field: string due_on = 11;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string moved_from_due_on = 12;
   */ _define_property(this, "movedFromDueOn", ""), /**
   * @generated from field: string moved_reason = 13;
   */ _define_property(this, "movedReason", ""), /**
   * @generated from field: string waived_on = 14;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string waiver_reason = 15;
   */ _define_property(this, "waiverReason", ""), /**
   * @generated from field: string waiver_document_id = 16;
   */ _define_property(this, "waiverDocumentId", ""), /**
   * @generated from field: bool retired = 17;
   */ _define_property(this, "retired", false), /**
   * @generated from field: string retired_reason = 18;
   */ _define_property(this, "retiredReason", ""), /**
   * @generated from field: string retired_by_modification_id = 19;
   */ _define_property(this, "retiredByModificationId", ""), /**
   * @generated from field: string retired_by_user_id = 20;
   */ _define_property(this, "retiredByUserId", ""), /**
   * @generated from field: string created_by_user_id = 21;
   */ _define_property(this, "createdByUserId", ""), /**
   * @generated from field: mono.datagateway.v1.OccurrenceStatus status = 22;
   */ _define_property(this, "status", void 0), /**
   * latest_submission is the date's latest live (not withdrawn) submission,
   * unset when none; on ListOccurrences, GetOccurrence and
   * ListOccurrenceDecisions rows.
   *
   * @generated from field: mono.datagateway.v1.OccurrenceSubmissionSummary latest_submission = 23;
   */ _define_property(this, "latestSubmission", void 0), /**
   * Derived at read time from live occurrences; never persisted.
   *
   * @generated from field: bool reassigned = 24;
   */ _define_property(this, "reassigned", false), /**
   * event is set on a date of a duty that dates an event, and on a projected
   * row (ListOccurrences include_projected). Derived at read time.
   *
   * @generated from field: mono.datagateway.v1.OccurrenceEvent event = 25;
   */ _define_property(this, "event", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractOccurrence, "runtime", proto3);
_define_property(ContractOccurrence, "typeName", "mono.datagateway.v1.ContractOccurrence");
_define_property(ContractOccurrence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "nominal_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "moved_from_due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "moved_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "waiver_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 18,
            name: "retired_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "retired_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "retired_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "created_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "status",
            kind: "message",
            T: OccurrenceStatus
        },
        {
            no: 23,
            name: "latest_submission",
            kind: "message",
            T: OccurrenceSubmissionSummary
        },
        {
            no: 24,
            name: "reassigned",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 25,
            name: "event",
            kind: "message",
            T: OccurrenceEvent
        }
    ]));
/**
 * OccurrenceEvent ties a date to an event (S6). On a date of a duty that
 * dates the event, held_on and event_id are the logged event that met it
 * (status "held"), unset while none has. On a projected row (status
 * "waiting_on_event", never stored, never late) projected is set, planned_on
 * is the event's planned date and holding_occurrence_id the date it comes
 * from; the row's id is not an occurrence id any verb takes.
 *
 * @generated from message mono.datagateway.v1.OccurrenceEvent
 */ export class OccurrenceEvent extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * name is how the event reads: the title of the duty that dates it, else
   * its kind in words.
   *
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string held_on = 3;
   */ _define_property(this, "heldOn", ""), /**
   * @generated from field: string event_id = 4;
   */ _define_property(this, "eventId", ""), /**
   * business_days_late: federal workdays from the holding date to held_on.
   *
   * @generated from field: int32 business_days_late = 5;
   */ _define_property(this, "businessDaysLate", 0), /**
   * @generated from field: bool projected = 6;
   */ _define_property(this, "projected", false), /**
   * @generated from field: string planned_on = 7;
   */ _define_property(this, "plannedOn", ""), /**
   * @generated from field: string holding_occurrence_id = 8;
   */ _define_property(this, "holdingOccurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceEvent, "runtime", proto3);
_define_property(OccurrenceEvent, "typeName", "mono.datagateway.v1.OccurrenceEvent");
_define_property(OccurrenceEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "held_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_days_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "projected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "planned_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "holding_occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * OccurrenceSubmissionSummary is a list row's view of its latest filing.
 *
 * @generated from message mono.datagateway.v1.OccurrenceSubmissionSummary
 */ export class OccurrenceSubmissionSummary extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceSubmissionSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceSubmissionSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceSubmissionSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceSubmissionSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string submission_id = 1;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: int32 attempt = 2;
   */ _define_property(this, "attempt", 0), /**
   * @generated from field: string submitted_on = 3;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_by_display = 4;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmissionAttachment attachments = 5;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceSubmissionSummary, "runtime", proto3);
_define_property(OccurrenceSubmissionSummary, "typeName", "mono.datagateway.v1.OccurrenceSubmissionSummary");
_define_property(OccurrenceSubmissionSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "attempt",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "attachments",
            kind: "message",
            T: ContractSubmissionAttachment,
            repeated: true
        }
    ]));
/**
 * OccurrenceStatus is occurrencestatus.Status on the request's as_of day.
 *
 * @generated from message mono.datagateway.v1.OccurrenceStatus
 */ export class OccurrenceStatus extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceStatus, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string state = 1;
   */ _define_property(this, "state", ""), /**
   * @generated from field: bool waived = 2;
   */ _define_property(this, "waived", false), /**
   * @generated from field: int32 attempt = 3;
   */ _define_property(this, "attempt", 0), /**
   * @generated from field: bool timing_known = 4;
   */ _define_property(this, "timingKnown", false), /**
   * @generated from field: bool on_time = 5;
   */ _define_property(this, "onTime", false), /**
   * @generated from field: int32 days_late = 6;
   */ _define_property(this, "daysLate", 0), /**
   * @generated from field: bool auto_approved = 7;
   */ _define_property(this, "autoApproved", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceStatus, "runtime", proto3);
_define_property(OccurrenceStatus, "typeName", "mono.datagateway.v1.OccurrenceStatus");
_define_property(OccurrenceStatus, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "waived",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "attempt",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "timing_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "on_time",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "days_late",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "auto_approved",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractEvent
 */ export class ContractEvent extends Message {
    static fromBinary(bytes, options) {
        return new ContractEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string occurred_on = 6;
   */ _define_property(this, "occurredOn", ""), /**
   * @generated from field: string label = 7;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string source_document_id = 8;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 9;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string recorded_by_user_id = 10;
   */ _define_property(this, "recordedByUserId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractEvent, "runtime", proto3);
_define_property(ContractEvent, "typeName", "mono.datagateway.v1.ContractEvent");
_define_property(ContractEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "occurred_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "recorded_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractWorkstream
 */ export class ContractWorkstream extends Message {
    static fromBinary(bytes, options) {
        return new ContractWorkstream().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractWorkstream().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractWorkstream().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractWorkstream, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: repeated string aliases = 4;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string named_by_modification_id = 5;
   */ _define_property(this, "namedByModificationId", ""), /**
   * @generated from field: string owner_contact_id = 6;
   */ _define_property(this, "ownerContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractWorkstream, "runtime", proto3);
_define_property(ContractWorkstream, "typeName", "mono.datagateway.v1.ContractWorkstream");
_define_property(ContractWorkstream, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "named_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractWorkstreamLineage
 */ export class ContractWorkstreamLineage extends Message {
    static fromBinary(bytes, options) {
        return new ContractWorkstreamLineage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractWorkstreamLineage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractWorkstreamLineage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractWorkstreamLineage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string predecessor_workstream_id = 2;
   */ _define_property(this, "predecessorWorkstreamId", ""), /**
   * @generated from field: string successor_workstream_id = 3;
   */ _define_property(this, "successorWorkstreamId", ""), /**
   * @generated from field: string effective_on = 4;
   */ _define_property(this, "effectiveOn", ""), /**
   * @generated from field: string source_document_id = 5;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 6;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractWorkstreamLineage, "runtime", proto3);
_define_property(ContractWorkstreamLineage, "typeName", "mono.datagateway.v1.ContractWorkstreamLineage");
_define_property(ContractWorkstreamLineage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "predecessor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "successor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "effective_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSow
 */ export class ContractSow extends Message {
    static fromBinary(bytes, options) {
        return new ContractSow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string version = 4;
   */ _define_property(this, "version", ""), /**
   * @generated from field: string approved_on = 5;
   */ _define_property(this, "approvedOn", ""), /**
   * @generated from field: string pop_start = 6;
   */ _define_property(this, "popStart", ""), /**
   * @generated from field: string pop_end = 7;
   */ _define_property(this, "popEnd", ""), /**
   * @generated from field: string program_document_id = 8;
   */ _define_property(this, "programDocumentId", ""), /**
   * @generated from field: bool terms_known = 9;
   */ _define_property(this, "termsKnown", false), /**
   * @generated from field: string named_in_sow_id = 10;
   */ _define_property(this, "namedInSowId", ""), /**
   * @generated from field: string named_in_locator = 11;
   */ _define_property(this, "namedInLocator", ""), /**
   * @generated from field: string named_in_quote = 12;
   */ _define_property(this, "namedInQuote", ""), /**
   * @generated from field: string supersedes_sow_id = 13;
   */ _define_property(this, "supersedesSowId", ""), /**
   * state is derived on the request's as_of day: approved_waiting | in_force | ended.
   *
   * @generated from field: string state = 14;
   */ _define_property(this, "state", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSow, "runtime", proto3);
_define_property(ContractSow, "typeName", "mono.datagateway.v1.ContractSow");
_define_property(ContractSow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "approved_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pop_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "pop_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "program_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "terms_known",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 10,
            name: "named_in_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "named_in_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "named_in_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "supersedes_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SowGapRuling
 */ export class SowGapRuling extends Message {
    static fromBinary(bytes, options) {
        return new SowGapRuling().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowGapRuling().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowGapRuling().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowGapRuling, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string from_on = 3;
   */ _define_property(this, "fromOn", ""), /**
   * @generated from field: string to_on = 4;
   */ _define_property(this, "toOn", ""), /**
   * @generated from field: string ruling = 5;
   */ _define_property(this, "ruling", ""), /**
   * @generated from field: string sow_id = 6;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string decided_by_user_id = 7;
   */ _define_property(this, "decidedByUserId", ""), /**
   * @generated from field: string change_item_id = 8;
   */ _define_property(this, "changeItemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowGapRuling, "runtime", proto3);
_define_property(SowGapRuling, "typeName", "mono.datagateway.v1.SowGapRuling");
_define_property(SowGapRuling, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "from_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "to_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ruling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "change_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSubmissionAttachment
 */ export class ContractSubmissionAttachment extends Message {
    static fromBinary(bytes, options) {
        return new ContractSubmissionAttachment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSubmissionAttachment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSubmissionAttachment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSubmissionAttachment, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string url = 3;
   */ _define_property(this, "url", ""), /**
   * link_kind is derived by the database from url.
   *
   * @generated from field: string link_kind = 4;
   */ _define_property(this, "linkKind", ""), /**
   * @generated from field: string label = 5;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSubmissionAttachment, "runtime", proto3);
_define_property(ContractSubmissionAttachment, "typeName", "mono.datagateway.v1.ContractSubmissionAttachment");
_define_property(ContractSubmissionAttachment, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "link_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSubmissionReview
 */ export class ContractSubmissionReview extends Message {
    static fromBinary(bytes, options) {
        return new ContractSubmissionReview().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSubmissionReview().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSubmissionReview().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSubmissionReview, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string submission_id = 2;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string tier = 3;
   */ _define_property(this, "tier", ""), /**
   * @generated from field: string decision = 4;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reviewer_contact_id = 5;
   */ _define_property(this, "reviewerContactId", ""), /**
   * @generated from field: string reviewer_display = 6;
   */ _define_property(this, "reviewerDisplay", ""), /**
   * @generated from field: string decided_on = 7;
   */ _define_property(this, "decidedOn", ""), /**
   * @generated from field: string notes = 8;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string evidence_artifact_id = 9;
   */ _define_property(this, "evidenceArtifactId", ""), /**
   * @generated from field: string recorded_by_user_id = 10;
   */ _define_property(this, "recordedByUserId", ""), /**
   * @generated from field: string superseded_by_id = 11;
   */ _define_property(this, "supersededById", ""), /**
   * @generated from field: bool superseded = 12;
   */ _define_property(this, "superseded", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSubmissionReview, "runtime", proto3);
_define_property(ContractSubmissionReview, "typeName", "mono.datagateway.v1.ContractSubmissionReview");
_define_property(ContractSubmissionReview, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reviewer_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reviewer_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "decided_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "evidence_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "recorded_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "superseded_by_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "superseded",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ContractSubmission
 */ export class ContractSubmission extends Message {
    static fromBinary(bytes, options) {
        return new ContractSubmission().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContractSubmission().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContractSubmission().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContractSubmission, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string occurrence_id = 2;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string sibling_of_submission_id = 3;
   */ _define_property(this, "siblingOfSubmissionId", ""), /**
   * attempt is derived: the submission's place among its occurrence's.
   *
   * @generated from field: int32 attempt = 4;
   */ _define_property(this, "attempt", 0), /**
   * @generated from field: string submitted_on = 5;
   */ _define_property(this, "submittedOn", ""), /**
   * submitted_at is RFC 3339, set only when the source gave an instant.
   *
   * @generated from field: string submitted_at = 6;
   */ _define_property(this, "submittedAt", ""), /**
   * @generated from field: string submitted_by_contact_id = 7;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 8;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 9;
   */ _define_property(this, "sentToContactIds", []), /**
   * @generated from field: string note = 10;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string recorded_by_user_id = 11;
   */ _define_property(this, "recordedByUserId", ""), /**
   * @generated from field: bool withdrawn = 12;
   */ _define_property(this, "withdrawn", false), /**
   * @generated from field: string withdrawn_reason = 13;
   */ _define_property(this, "withdrawnReason", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmissionAttachment attachments = 14;
   */ _define_property(this, "attachments", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmissionReview reviews = 15;
   */ _define_property(this, "reviews", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ContractSubmission, "runtime", proto3);
_define_property(ContractSubmission, "typeName", "mono.datagateway.v1.ContractSubmission");
_define_property(ContractSubmission, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sibling_of_submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "attempt",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "submitted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "recorded_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "withdrawn",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "withdrawn_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "attachments",
            kind: "message",
            T: ContractSubmissionAttachment,
            repeated: true
        },
        {
            no: 15,
            name: "reviews",
            kind: "message",
            T: ContractSubmissionReview,
            repeated: true
        }
    ]));
/**
 * DutyCheck is a read-time check (design §6.2): a warning shown on the duty,
 * never staged. fix_verb names the RPC that clears it.
 *
 * @generated from message mono.datagateway.v1.DutyCheck
 */ export class DutyCheck extends Message {
    static fromBinary(bytes, options) {
        return new DutyCheck().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyCheck().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyCheck().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyCheck, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string code = 1;
   */ _define_property(this, "code", ""), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", ""), /**
   * @generated from field: string fix_verb = 3;
   */ _define_property(this, "fixVerb", ""), /**
   * @generated from field: string rule_id = 4;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: string workstream_id = 5;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string period_of_performance_id = 6;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string exercise_id = 7;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string from_on = 8;
   */ _define_property(this, "fromOn", ""), /**
   * @generated from field: string to_on = 9;
   */ _define_property(this, "toOn", ""), /**
   * suggested_on is a date the reviewer may accept, never applied by itself
   * (D98, D107): on a needs_start_date check of a receipt-of-order rule on an
   * option period, the effective date of the one applied modification that
   * exercised the period. suggested_label is that modification's number
   * (P00003) and suggested_document_id its program document, when on file.
   *
   * @generated from field: string suggested_on = 10;
   */ _define_property(this, "suggestedOn", ""), /**
   * @generated from field: string suggested_label = 11;
   */ _define_property(this, "suggestedLabel", ""), /**
   * @generated from field: string suggested_document_id = 12;
   */ _define_property(this, "suggestedDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyCheck, "runtime", proto3);
_define_property(DutyCheck, "typeName", "mono.datagateway.v1.DutyCheck");
_define_property(DutyCheck, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "code",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "fix_verb",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "from_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "to_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "suggested_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "suggested_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "suggested_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * DutyCheckCodes is one duty's check codes.
 *
 * @generated from message mono.datagateway.v1.DutyCheckCodes
 */ export class DutyCheckCodes extends Message {
    static fromBinary(bytes, options) {
        return new DutyCheckCodes().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyCheckCodes().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyCheckCodes().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyCheckCodes, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated string codes = 1;
   */ _define_property(this, "codes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyCheckCodes, "runtime", proto3);
_define_property(DutyCheckCodes, "typeName", "mono.datagateway.v1.DutyCheckCodes");
_define_property(DutyCheckCodes, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "codes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * DutyFields is a duty's writable content.
 *
 * @generated from message mono.datagateway.v1.DutyFields
 */ export class DutyFields extends Message {
    static fromBinary(bytes, options) {
        return new DutyFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DutyFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DutyFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DutyFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string title = 1;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string pws_ref = 2;
   */ _define_property(this, "pwsRef", ""), /**
   * @generated from field: string letter = 3;
   */ _define_property(this, "letter", ""), /**
   * @generated from field: repeated string aliases = 4;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string description = 5;
   */ _define_property(this, "description", ""), /**
   * @generated from field: string format = 6;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 7;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 8;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * final_review_tier "" takes the default (va_pm).
   *
   * @generated from field: string final_review_tier = 9;
   */ _define_property(this, "finalReviewTier", ""), /**
   * @generated from field: string source_document_id = 10;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 11;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string introduced_by_modification_id = 12;
   */ _define_property(this, "introducedByModificationId", ""), /**
   * @generated from field: string ended_by_modification_id = 13;
   */ _define_property(this, "endedByModificationId", ""), /**
   * @generated from field: string ended_on = 14;
   */ _define_property(this, "endedOn", ""), /**
   * event_kind: the event this duty dates ("" = none). One live duty per
   * kind; native kinds and on_request are refused.
   *
   * @generated from field: string event_kind = 15;
   */ _define_property(this, "eventKind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DutyFields, "runtime", proto3);
_define_property(DutyFields, "typeName", "mono.datagateway.v1.DutyFields");
_define_property(DutyFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pws_ref",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "letter",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "description",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "final_review_tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "introduced_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "ended_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "ended_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDutyRequest
 */ export class CreateDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_key = 4;
   */ _define_property(this, "dutyKey", ""), /**
   * origin: award | modification | sow | manual; "" = manual.
   *
   * @generated from field: string origin = 5;
   */ _define_property(this, "origin", ""), /**
   * sow_id is required with origin "sow", which also writes the SOW's
   * automatic "performed" assignment (design §2.3).
   *
   * @generated from field: string sow_id = 6;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: mono.datagateway.v1.DutyFields fields = 7;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDutyRequest, "runtime", proto3);
_define_property(CreateDutyRequest, "typeName", "mono.datagateway.v1.CreateDutyRequest");
_define_property(CreateDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "origin",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "fields",
            kind: "message",
            T: DutyFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateDutyResponse
 */ export class CreateDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDuty duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateDutyResponse, "runtime", proto3);
_define_property(CreateDutyResponse, "typeName", "mono.datagateway.v1.CreateDutyResponse");
_define_property(CreateDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: ContractDuty
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateDutyRequest replaces the duty's writable content. duty_key and origin
 * are its identity and never change.
 *
 * @generated from message mono.datagateway.v1.UpdateDutyRequest
 */ export class UpdateDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: mono.datagateway.v1.DutyFields fields = 5;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDutyRequest, "runtime", proto3);
_define_property(UpdateDutyRequest, "typeName", "mono.datagateway.v1.UpdateDutyRequest");
_define_property(UpdateDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fields",
            kind: "message",
            T: DutyFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDutyResponse
 */ export class UpdateDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDuty duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDutyResponse, "runtime", proto3);
_define_property(UpdateDutyResponse, "typeName", "mono.datagateway.v1.UpdateDutyResponse");
_define_property(UpdateDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: ContractDuty
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDutyRequest
 */ export class DeleteDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDutyRequest, "runtime", proto3);
_define_property(DeleteDutyRequest, "typeName", "mono.datagateway.v1.DeleteDutyRequest");
_define_property(DeleteDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteDutyResponse
 */ export class DeleteDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteDutyResponse, "runtime", proto3);
_define_property(DeleteDutyResponse, "typeName", "mono.datagateway.v1.DeleteDutyResponse");
_define_property(DeleteDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDutyRequest
 */ export class GetDutyRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDutyRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDutyRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDutyRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDutyRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string duty_id = 3;
   */ _define_property(this, "dutyId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDutyRequest, "runtime", proto3);
_define_property(GetDutyRequest, "typeName", "mono.datagateway.v1.GetDutyRequest");
_define_property(GetDutyRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDutyResponse
 */ export class GetDutyResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDutyResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDutyResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDutyResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDutyResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDuty duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * rules are the award rules; team rules ride on their assignment.
   *
   * @generated from field: repeated mono.datagateway.v1.ContractScheduleRule rules = 2;
   */ _define_property(this, "rules", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractDutyAssignment assignments = 3;
   */ _define_property(this, "assignments", []), /**
   * @generated from field: repeated mono.datagateway.v1.DutyCheck checks = 4;
   */ _define_property(this, "checks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDutyResponse, "runtime", proto3);
_define_property(GetDutyResponse, "typeName", "mono.datagateway.v1.GetDutyResponse");
_define_property(GetDutyResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: ContractDuty
        },
        {
            no: 2,
            name: "rules",
            kind: "message",
            T: ContractScheduleRule,
            repeated: true
        },
        {
            no: 3,
            name: "assignments",
            kind: "message",
            T: ContractDutyAssignment,
            repeated: true
        },
        {
            no: 4,
            name: "checks",
            kind: "message",
            T: DutyCheck,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDutiesRequest
 */ export class ListDutiesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListDutiesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDutiesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDutiesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDutiesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * include_rules: also return every live rule of the duties (award and
   * team), e.g. to read each duty's CLIN (rule clin_id).
   *
   * @generated from field: bool include_rules = 3;
   */ _define_property(this, "includeRules", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDutiesRequest, "runtime", proto3);
_define_property(ListDutiesRequest, "typeName", "mono.datagateway.v1.ListDutiesRequest");
_define_property(ListDutiesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "include_rules",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListDutiesResponse
 */ export class ListDutiesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListDutiesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListDutiesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListDutiesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListDutiesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractDuty duties = 1;
   */ _define_property(this, "duties", []), /**
   * check_codes: each duty's GetDuty check codes, by duty id (a duty with
   * none is absent), so a list can badge "needs a start date" without a
   * GetDuty per row.
   *
   * @generated from field: map<string, mono.datagateway.v1.DutyCheckCodes> check_codes = 2;
   */ _define_property(this, "checkCodes", {}), /**
   * rules is set only with include_rules.
   *
   * @generated from field: repeated mono.datagateway.v1.ContractScheduleRule rules = 3;
   */ _define_property(this, "rules", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListDutiesResponse, "runtime", proto3);
_define_property(ListDutiesResponse, "typeName", "mono.datagateway.v1.ListDutiesResponse");
_define_property(ListDutiesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duties",
            kind: "message",
            T: ContractDuty,
            repeated: true
        },
        {
            no: 2,
            name: "check_codes",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "message",
                T: DutyCheckCodes
            }
        },
        {
            no: 3,
            name: "rules",
            kind: "message",
            T: ContractScheduleRule,
            repeated: true
        }
    ]));
/**
 * ScheduleRuleFields is a rule's typed content (migration 000212's columns).
 *
 * @generated from message mono.datagateway.v1.ScheduleRuleFields
 */ export class ScheduleRuleFields extends Message {
    static fromBinary(bytes, options) {
        return new ScheduleRuleFields().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScheduleRuleFields().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScheduleRuleFields().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScheduleRuleFields, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string clin_id = 1;
   */ _define_property(this, "clinId", ""), /**
   * @generated from field: string gate = 2;
   */ _define_property(this, "gate", ""), /**
   * @generated from field: string period_of_performance_id = 3;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string optional_task_id = 4;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string due_on = 6;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: bool has_offset = 7;
   */ _define_property(this, "hasOffset", false), /**
   * @generated from field: int32 offset_n = 8;
   */ _define_property(this, "offsetN", 0), /**
   * @generated from field: string offset_unit = 9;
   */ _define_property(this, "offsetUnit", ""), /**
   * @generated from field: string cadence = 10;
   */ _define_property(this, "cadence", ""), /**
   * cadence_interval 0 = 1.
   *
   * @generated from field: int32 cadence_interval = 11;
   */ _define_property(this, "cadenceInterval", 0), /**
   * @generated from field: repeated int32 day_ordinals = 12;
   */ _define_property(this, "dayOrdinals", []), /**
   * @generated from field: string day_weekday = 13;
   */ _define_property(this, "dayWeekday", ""), /**
   * @generated from field: string day_basis = 14;
   */ _define_property(this, "dayBasis", ""), /**
   * @generated from field: string event_kind = 15;
   */ _define_property(this, "eventKind", ""), /**
   * @generated from field: repeated string subjects = 16;
   */ _define_property(this, "subjects", []), /**
   * @generated from field: string rule_text = 17;
   */ _define_property(this, "ruleText", ""), /**
   * @generated from field: string source_document_id = 18;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 19;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string effective_from = 20;
   */ _define_property(this, "effectiveFrom", ""), /**
   * @generated from field: string effective_to = 21;
   */ _define_property(this, "effectiveTo", ""), /**
   * @generated from field: string established_by_modification_id = 22;
   */ _define_property(this, "establishedByModificationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ScheduleRuleFields, "runtime", proto3);
_define_property(ScheduleRuleFields, "typeName", "mono.datagateway.v1.ScheduleRuleFields");
_define_property(ScheduleRuleFields, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "gate",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "has_offset",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "offset_n",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "offset_unit",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "cadence",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "cadence_interval",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 12,
            name: "day_ordinals",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ ,
            repeated: true
        },
        {
            no: 13,
            name: "day_weekday",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "day_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "event_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "subjects",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 17,
            name: "rule_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 19,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 20,
            name: "effective_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 21,
            name: "effective_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 22,
            name: "established_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateScheduleRuleRequest
 */ export class CreateScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: mono.datagateway.v1.ScheduleRuleFields fields = 5;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateScheduleRuleRequest, "runtime", proto3);
_define_property(CreateScheduleRuleRequest, "typeName", "mono.datagateway.v1.CreateScheduleRuleRequest");
_define_property(CreateScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fields",
            kind: "message",
            T: ScheduleRuleFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateScheduleRuleResponse
 */ export class CreateScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractScheduleRule rule = 1;
   */ _define_property(this, "rule", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateScheduleRuleResponse, "runtime", proto3);
_define_property(CreateScheduleRuleResponse, "typeName", "mono.datagateway.v1.CreateScheduleRuleResponse");
_define_property(CreateScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rule",
            kind: "message",
            T: ContractScheduleRule
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateScheduleRuleRequest replaces the rule's content in place (the fix for
 * "needs a start date"). A mod's change is a new rule, not an edit.
 *
 * @generated from message mono.datagateway.v1.UpdateScheduleRuleRequest
 */ export class UpdateScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string rule_id = 4;
   */ _define_property(this, "ruleId", ""), /**
   * @generated from field: mono.datagateway.v1.ScheduleRuleFields fields = 5;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateScheduleRuleRequest, "runtime", proto3);
_define_property(UpdateScheduleRuleRequest, "typeName", "mono.datagateway.v1.UpdateScheduleRuleRequest");
_define_property(UpdateScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "fields",
            kind: "message",
            T: ScheduleRuleFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateScheduleRuleResponse
 */ export class UpdateScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractScheduleRule rule = 1;
   */ _define_property(this, "rule", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateScheduleRuleResponse, "runtime", proto3);
_define_property(UpdateScheduleRuleResponse, "typeName", "mono.datagateway.v1.UpdateScheduleRuleResponse");
_define_property(UpdateScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rule",
            kind: "message",
            T: ContractScheduleRule
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteScheduleRuleRequest
 */ export class DeleteScheduleRuleRequest extends Message {
    static fromBinary(bytes, options) {
        return new DeleteScheduleRuleRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteScheduleRuleRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteScheduleRuleRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteScheduleRuleRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string rule_id = 4;
   */ _define_property(this, "ruleId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteScheduleRuleRequest, "runtime", proto3);
_define_property(DeleteScheduleRuleRequest, "typeName", "mono.datagateway.v1.DeleteScheduleRuleRequest");
_define_property(DeleteScheduleRuleRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "rule_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.DeleteScheduleRuleResponse
 */ export class DeleteScheduleRuleResponse extends Message {
    static fromBinary(bytes, options) {
        return new DeleteScheduleRuleResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeleteScheduleRuleResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeleteScheduleRuleResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeleteScheduleRuleResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeleteScheduleRuleResponse, "runtime", proto3);
_define_property(DeleteScheduleRuleResponse, "typeName", "mono.datagateway.v1.DeleteScheduleRuleResponse");
_define_property(DeleteScheduleRuleResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddOccurrenceRequest
 */ export class AddOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string duty_id = 4;
   */ _define_property(this, "dutyId", ""), /**
   * due_on "" = due unknown.
   *
   * @generated from field: string due_on = 5;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string label = 6;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string workstream_id = 7;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string period_of_performance_id = 8;
   */ _define_property(this, "periodOfPerformanceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddOccurrenceRequest, "runtime", proto3);
_define_property(AddOccurrenceRequest, "typeName", "mono.datagateway.v1.AddOccurrenceRequest");
_define_property(AddOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddOccurrenceResponse
 */ export class AddOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddOccurrenceResponse, "runtime", proto3);
_define_property(AddOccurrenceResponse, "typeName", "mono.datagateway.v1.AddOccurrenceResponse");
_define_property(AddOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveOccurrenceRequest
 */ export class RemoveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new RemoveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveOccurrenceRequest, "runtime", proto3);
_define_property(RemoveOccurrenceRequest, "typeName", "mono.datagateway.v1.RemoveOccurrenceRequest");
_define_property(RemoveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RemoveOccurrenceResponse
 */ export class RemoveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new RemoveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RemoveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RemoveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RemoveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 1;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RemoveOccurrenceResponse, "runtime", proto3);
_define_property(RemoveOccurrenceResponse, "typeName", "mono.datagateway.v1.RemoveOccurrenceResponse");
_define_property(RemoveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MoveOccurrenceRequest
 */ export class MoveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new MoveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string due_on = 5;
   */ _define_property(this, "dueOn", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveOccurrenceRequest, "runtime", proto3);
_define_property(MoveOccurrenceRequest, "typeName", "mono.datagateway.v1.MoveOccurrenceRequest");
_define_property(MoveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "due_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MoveOccurrenceResponse
 */ export class MoveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new MoveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoveOccurrenceResponse, "runtime", proto3);
_define_property(MoveOccurrenceResponse, "typeName", "mono.datagateway.v1.MoveOccurrenceResponse");
_define_property(MoveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WaiveOccurrenceRequest
 */ export class WaiveOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new WaiveOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WaiveOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WaiveOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WaiveOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string waived_on = 5;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string waiver_document_id = 7;
   */ _define_property(this, "waiverDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WaiveOccurrenceRequest, "runtime", proto3);
_define_property(WaiveOccurrenceRequest, "typeName", "mono.datagateway.v1.WaiveOccurrenceRequest");
_define_property(WaiveOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WaiveOccurrenceResponse
 */ export class WaiveOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new WaiveOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WaiveOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WaiveOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WaiveOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WaiveOccurrenceResponse, "runtime", proto3);
_define_property(WaiveOccurrenceResponse, "typeName", "mono.datagateway.v1.WaiveOccurrenceResponse");
_define_property(WaiveOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkOccurrenceNotOwedRequest
 */ export class MarkOccurrenceNotOwedRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkOccurrenceNotOwedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkOccurrenceNotOwedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkOccurrenceNotOwedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkOccurrenceNotOwedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * reason: not_owed | generated_in_error.
   *
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * note is required: why, in words; kept on the audit event.
   *
   * @generated from field: string note = 6;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkOccurrenceNotOwedRequest, "runtime", proto3);
_define_property(MarkOccurrenceNotOwedRequest, "typeName", "mono.datagateway.v1.MarkOccurrenceNotOwedRequest");
_define_property(MarkOccurrenceNotOwedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.MarkOccurrenceNotOwedResponse
 */ export class MarkOccurrenceNotOwedResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkOccurrenceNotOwedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkOccurrenceNotOwedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkOccurrenceNotOwedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkOccurrenceNotOwedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkOccurrenceNotOwedResponse, "runtime", proto3);
_define_property(MarkOccurrenceNotOwedResponse, "typeName", "mono.datagateway.v1.MarkOccurrenceNotOwedResponse");
_define_property(MarkOccurrenceNotOwedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * OccurrenceDecision is a proposed waiver or not-owed mark (D111): an
 * OccurrenceDecision change set with one item.
 *
 * @generated from message mono.datagateway.v1.OccurrenceDecision
 */ export class OccurrenceDecision extends Message {
    static fromBinary(bytes, options) {
        return new OccurrenceDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OccurrenceDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OccurrenceDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OccurrenceDecision, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string change_set_id = 1;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string item_id = 2;
   */ _define_property(this, "itemId", ""), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * kind: waiver | not_owed.
   *
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * state: the change set's (UnderReview, Applied, Rejected, ...).
   *
   * @generated from field: string state = 5;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string proposed_by_user_id = 6;
   */ _define_property(this, "proposedByUserId", ""), /**
   * @generated from field: string approved_by_user_id = 7;
   */ _define_property(this, "approvedByUserId", ""), /**
   * @generated from field: string waived_on = 8;
   */ _define_property(this, "waivedOn", ""), /**
   * reason: the waiver's reason, or not_owed | generated_in_error.
   *
   * @generated from field: string reason = 9;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string waiver_document_id = 10;
   */ _define_property(this, "waiverDocumentId", ""), /**
   * @generated from field: string note = 11;
   */ _define_property(this, "note", ""), /**
   * state_reason is why a Rejected or Cancelled proposal ended.
   *
   * @generated from field: string state_reason = 12;
   */ _define_property(this, "stateReason", ""), /**
   * decided_by_user_id is who ended it: the approver (Applied), the
   * rejecter (Rejected) or the proposer (Cancelled, withdrawn).
   *
   * @generated from field: string decided_by_user_id = 13;
   */ _define_property(this, "decidedByUserId", ""), /**
   * proposed_at / decided_at are RFC 3339 instants; decided_at is "" while open.
   *
   * @generated from field: string proposed_at = 14;
   */ _define_property(this, "proposedAt", ""), /**
   * @generated from field: string decided_at = 15;
   */ _define_property(this, "decidedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(OccurrenceDecision, "runtime", proto3);
_define_property(OccurrenceDecision, "typeName", "mono.datagateway.v1.OccurrenceDecision");
_define_property(OccurrenceDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "proposed_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "approved_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "state_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "decided_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "proposed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "decided_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceWaiverRequest
 */ export class ProposeOccurrenceWaiverRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceWaiverRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceWaiverRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceWaiverRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceWaiverRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string waived_on = 4;
   */ _define_property(this, "waivedOn", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string waiver_document_id = 6;
   */ _define_property(this, "waiverDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceWaiverRequest, "runtime", proto3);
_define_property(ProposeOccurrenceWaiverRequest, "typeName", "mono.datagateway.v1.ProposeOccurrenceWaiverRequest");
_define_property(ProposeOccurrenceWaiverRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "waived_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "waiver_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceWaiverResponse
 */ export class ProposeOccurrenceWaiverResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceWaiverResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceWaiverResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceWaiverResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceWaiverResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceWaiverResponse, "runtime", proto3);
_define_property(ProposeOccurrenceWaiverResponse, "typeName", "mono.datagateway.v1.ProposeOccurrenceWaiverResponse");
_define_property(ProposeOccurrenceWaiverResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceNotOwedRequest
 */ export class ProposeOccurrenceNotOwedRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceNotOwedRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceNotOwedRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceNotOwedRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceNotOwedRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * reason: not_owed | generated_in_error.
   *
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string note = 5;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceNotOwedRequest, "runtime", proto3);
_define_property(ProposeOccurrenceNotOwedRequest, "typeName", "mono.datagateway.v1.ProposeOccurrenceNotOwedRequest");
_define_property(ProposeOccurrenceNotOwedRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ProposeOccurrenceNotOwedResponse
 */ export class ProposeOccurrenceNotOwedResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposeOccurrenceNotOwedResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposeOccurrenceNotOwedResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposeOccurrenceNotOwedResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposeOccurrenceNotOwedResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposeOccurrenceNotOwedResponse, "runtime", proto3);
_define_property(ProposeOccurrenceNotOwedResponse, "typeName", "mono.datagateway.v1.ProposeOccurrenceNotOwedResponse");
_define_property(ProposeOccurrenceNotOwedResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApproveOccurrenceDecisionRequest
 */ export class ApproveOccurrenceDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ApproveOccurrenceDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveOccurrenceDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveOccurrenceDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveOccurrenceDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveOccurrenceDecisionRequest, "runtime", proto3);
_define_property(ApproveOccurrenceDecisionRequest, "typeName", "mono.datagateway.v1.ApproveOccurrenceDecisionRequest");
_define_property(ApproveOccurrenceDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ApproveOccurrenceDecisionResponse
 */ export class ApproveOccurrenceDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ApproveOccurrenceDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApproveOccurrenceDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApproveOccurrenceDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApproveOccurrenceDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 2;
   */ _define_property(this, "occurrence", void 0), /**
   * result.audit_event_id is the verb's own event (the item's applied event).
   *
   * @generated from field: mono.datagateway.v1.WriteResult result = 3;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ApproveOccurrenceDecisionResponse, "runtime", proto3);
_define_property(ApproveOccurrenceDecisionResponse, "typeName", "mono.datagateway.v1.ApproveOccurrenceDecisionResponse");
_define_property(ApproveOccurrenceDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 3,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectOccurrenceDecisionRequest
 */ export class RejectOccurrenceDecisionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectOccurrenceDecisionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectOccurrenceDecisionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectOccurrenceDecisionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectOccurrenceDecisionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string change_set_id = 3;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: string reason = 4;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectOccurrenceDecisionRequest, "runtime", proto3);
_define_property(RejectOccurrenceDecisionRequest, "typeName", "mono.datagateway.v1.RejectOccurrenceDecisionRequest");
_define_property(RejectOccurrenceDecisionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectOccurrenceDecisionResponse
 */ export class RejectOccurrenceDecisionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectOccurrenceDecisionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectOccurrenceDecisionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectOccurrenceDecisionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectOccurrenceDecisionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.OccurrenceDecision decision = 1;
   */ _define_property(this, "decision", void 0), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 2;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 3;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectOccurrenceDecisionResponse, "runtime", proto3);
_define_property(RejectOccurrenceDecisionResponse, "typeName", "mono.datagateway.v1.RejectOccurrenceDecisionResponse");
_define_property(RejectOccurrenceDecisionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decision",
            kind: "message",
            T: OccurrenceDecision
        },
        {
            no: 2,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 3,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrenceDecisionsRequest
 */ export class ListOccurrenceDecisionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrenceDecisionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrenceDecisionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrenceDecisionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrenceDecisionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * workstream_id: only proposals on that workstream's dates.
   *
   * @generated from field: string workstream_id = 2;
   */ _define_property(this, "workstreamId", ""), /**
   * open_only: only proposals still awaiting approval.
   *
   * @generated from field: bool open_only = 3;
   */ _define_property(this, "openOnly", false), /**
   * as_of is the day the occurrences' status is computed on; "" = today.
   *
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", ""), /**
   * occurrence_id: only proposals on that date.
   *
   * @generated from field: string occurrence_id = 5;
   */ _define_property(this, "occurrenceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrenceDecisionsRequest, "runtime", proto3);
_define_property(ListOccurrenceDecisionsRequest, "typeName", "mono.datagateway.v1.ListOccurrenceDecisionsRequest");
_define_property(ListOccurrenceDecisionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "open_only",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrenceDecisionsResponse
 */ export class ListOccurrenceDecisionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrenceDecisionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrenceDecisionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrenceDecisionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrenceDecisionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * decisions are newest first.
   *
   * @generated from field: repeated mono.datagateway.v1.OccurrenceDecision decisions = 1;
   */ _define_property(this, "decisions", []), /**
   * occurrences are the decisions' dates, with their status on as_of.
   *
   * @generated from field: repeated mono.datagateway.v1.ContractOccurrence occurrences = 2;
   */ _define_property(this, "occurrences", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrenceDecisionsResponse, "runtime", proto3);
_define_property(ListOccurrenceDecisionsResponse, "typeName", "mono.datagateway.v1.ListOccurrenceDecisionsResponse");
_define_property(ListOccurrenceDecisionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "decisions",
            kind: "message",
            T: OccurrenceDecision,
            repeated: true
        },
        {
            no: 2,
            name: "occurrences",
            kind: "message",
            T: ContractOccurrence,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOccurrenceRequest
 */ export class GetOccurrenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetOccurrenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOccurrenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOccurrenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOccurrenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string occurrence_id = 3;
   */ _define_property(this, "occurrenceId", ""), /**
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOccurrenceRequest, "runtime", proto3);
_define_property(GetOccurrenceRequest, "typeName", "mono.datagateway.v1.GetOccurrenceRequest");
_define_property(GetOccurrenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetOccurrenceResponse
 */ export class GetOccurrenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetOccurrenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetOccurrenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetOccurrenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetOccurrenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractOccurrence occurrence = 1;
   */ _define_property(this, "occurrence", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmission submissions = 2;
   */ _define_property(this, "submissions", []), /**
   * decisions are the date's proposals, newest first, in every state.
   *
   * @generated from field: repeated mono.datagateway.v1.OccurrenceDecision decisions = 3;
   */ _define_property(this, "decisions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetOccurrenceResponse, "runtime", proto3);
_define_property(GetOccurrenceResponse, "typeName", "mono.datagateway.v1.GetOccurrenceResponse");
_define_property(GetOccurrenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrence",
            kind: "message",
            T: ContractOccurrence
        },
        {
            no: 2,
            name: "submissions",
            kind: "message",
            T: ContractSubmission,
            repeated: true
        },
        {
            no: 3,
            name: "decisions",
            kind: "message",
            T: OccurrenceDecision,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrencesRequest
 */ export class ListOccurrencesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrencesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrencesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrencesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrencesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string duty_id = 3;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * states filters by occurrencestatus state; empty = every state.
   *
   * @generated from field: repeated string states = 5;
   */ _define_property(this, "states", []), /**
   * retired rows are included only when asked for.
   *
   * @generated from field: bool include_retired = 6;
   */ _define_property(this, "includeRetired", false), /**
   * @generated from field: mono.datagateway.v1.OccurrenceWindow window = 7;
   */ _define_property(this, "window", 0), /**
   * @generated from field: string as_of = 8;
   */ _define_property(this, "asOf", ""), /**
   * page_size 0 = every row.
   *
   * @generated from field: int32 page_size = 9;
   */ _define_property(this, "pageSize", 0), /**
   * @generated from field: string page_token = 10;
   */ _define_property(this, "pageToken", ""), /**
   * period_of_performance_id is required with OCCURRENCE_WINDOW_CONTRACT_PERIOD
   * and refused with any other window.
   *
   * @generated from field: string period_of_performance_id = 11;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * The row filters below narrow the rows like duty_id and workstream_id do:
   * state_counts, on_time and total are taken after them (only `states` is
   * applied after the counts).
   *
   * clin_id: rows minted by a rule on that CLIN, plus one-offs of a duty with
   * such a rule.
   *
   * @generated from field: string clin_id = 12;
   */ _define_property(this, "clinId", ""), /**
   * due_from / due_to: rows due in [due_from, due_to] ("" = open-ended); an
   * undated row is left out when either is set.
   *
   * @generated from field: string due_from = 13;
   */ _define_property(this, "dueFrom", ""), /**
   * @generated from field: string due_to = 14;
   */ _define_property(this, "dueTo", ""), /**
   * submitted_from / submitted_to: rows whose latest live submission was
   * submitted in [submitted_from, submitted_to]; an unfiled row is left out
   * when either is set.
   *
   * @generated from field: string submitted_from = 15;
   */ _define_property(this, "submittedFrom", ""), /**
   * @generated from field: string submitted_to = 16;
   */ _define_property(this, "submittedTo", ""), /**
   * include_projected adds the dates projected from events not logged yet
   * (S6): state "waiting_on_event", never late, counted in state_counts
   * under that state only.
   *
   * @generated from field: bool include_projected = 17;
   */ _define_property(this, "includeProjected", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrencesRequest, "runtime", proto3);
_define_property(ListOccurrencesRequest, "typeName", "mono.datagateway.v1.ListOccurrencesRequest");
_define_property(ListOccurrencesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "states",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "include_retired",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "window",
            kind: "enum",
            T: proto3.getEnumType(OccurrenceWindow)
        },
        {
            no: 8,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "clin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "due_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "due_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "submitted_from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "submitted_to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "include_projected",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * OnTimeCounts are the on-time KPI's named denominators over the rows
 * counted: approved rows, those whose timing is known, and those on time.
 *
 * @generated from message mono.datagateway.v1.OnTimeCounts
 */ export class OnTimeCounts extends Message {
    static fromBinary(bytes, options) {
        return new OnTimeCounts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new OnTimeCounts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new OnTimeCounts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(OnTimeCounts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 approved = 1;
   */ _define_property(this, "approved", 0), /**
   * @generated from field: int32 timing_known = 2;
   */ _define_property(this, "timingKnown", 0), /**
   * @generated from field: int32 on_time = 3;
   */ _define_property(this, "onTime", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(OnTimeCounts, "runtime", proto3);
_define_property(OnTimeCounts, "typeName", "mono.datagateway.v1.OnTimeCounts");
_define_property(OnTimeCounts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "approved",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "timing_known",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "on_time",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * ResolvedWindow is the window the filter used. basis names where it came
 * from: all | contract_period | sow_in_force | exercise_line | none (the
 * workstream has no current window: the rows are its open ones).
 *
 * @generated from message mono.datagateway.v1.ResolvedWindow
 */ export class ResolvedWindow extends Message {
    static fromBinary(bytes, options) {
        return new ResolvedWindow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ResolvedWindow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ResolvedWindow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ResolvedWindow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string basis = 1;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string start_on = 2;
   */ _define_property(this, "startOn", ""), /**
   * @generated from field: string end_on = 3;
   */ _define_property(this, "endOn", ""), /**
   * @generated from field: string period_of_performance_id = 4;
   */ _define_property(this, "periodOfPerformanceId", ""), /**
   * @generated from field: string sow_id = 5;
   */ _define_property(this, "sowId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ResolvedWindow, "runtime", proto3);
_define_property(ResolvedWindow, "typeName", "mono.datagateway.v1.ResolvedWindow");
_define_property(ResolvedWindow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "start_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "end_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_of_performance_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListOccurrencesResponse
 */ export class ListOccurrencesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListOccurrencesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListOccurrencesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListOccurrencesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListOccurrencesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractOccurrence occurrences = 1;
   */ _define_property(this, "occurrences", []), /**
   * state_counts is over the window before the state filter and paging: the
   * named denominators of the KPI strip.
   *
   * @generated from field: map<string, int32> state_counts = 2;
   */ _define_property(this, "stateCounts", {}), /**
   * total is the filtered row count before paging.
   *
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0), /**
   * @generated from field: mono.datagateway.v1.ResolvedWindow window = 4;
   */ _define_property(this, "window", void 0), /**
   * @generated from field: string as_of = 5;
   */ _define_property(this, "asOf", ""), /**
   * carried_over counts rows outside the window that are still open.
   *
   * @generated from field: int32 carried_over = 6;
   */ _define_property(this, "carriedOver", 0), /**
   * @generated from field: string next_page_token = 7;
   */ _define_property(this, "nextPageToken", ""), /**
   * on_time is over the same rows as state_counts.
   *
   * @generated from field: mono.datagateway.v1.OnTimeCounts on_time = 8;
   */ _define_property(this, "onTime", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListOccurrencesResponse, "runtime", proto3);
_define_property(ListOccurrencesResponse, "typeName", "mono.datagateway.v1.ListOccurrencesResponse");
_define_property(ListOccurrencesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "occurrences",
            kind: "message",
            T: ContractOccurrence,
            repeated: true
        },
        {
            no: 2,
            name: "state_counts",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "window",
            kind: "message",
            T: ResolvedWindow
        },
        {
            no: 5,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "carried_over",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "on_time",
            kind: "message",
            T: OnTimeCounts
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LogContractEventRequest
 */ export class LogContractEventRequest extends Message {
    static fromBinary(bytes, options) {
        return new LogContractEventRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogContractEventRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogContractEventRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogContractEventRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string occurred_on = 5;
   */ _define_property(this, "occurredOn", ""), /**
   * @generated from field: string workstream_id = 6;
   */ _define_property(this, "workstreamId", ""), /**
   * duty_id is required for kind "on_request" (which duty was requested)
   * and refused otherwise.
   *
   * @generated from field: string duty_id = 7;
   */ _define_property(this, "dutyId", ""), /**
   * @generated from field: string label = 8;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string source_document_id = 9;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 10;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogContractEventRequest, "runtime", proto3);
_define_property(LogContractEventRequest, "typeName", "mono.datagateway.v1.LogContractEventRequest");
_define_property(LogContractEventRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "occurred_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LogContractEventResponse
 */ export class LogContractEventResponse extends Message {
    static fromBinary(bytes, options) {
        return new LogContractEventResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LogContractEventResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LogContractEventResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LogContractEventResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractEvent event = 1;
   */ _define_property(this, "event", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LogContractEventResponse, "runtime", proto3);
_define_property(LogContractEventResponse, "typeName", "mono.datagateway.v1.LogContractEventResponse");
_define_property(LogContractEventResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "event",
            kind: "message",
            T: ContractEvent
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateWorkstreamRequest
 */ export class CreateWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string name = 4;
   */ _define_property(this, "name", ""), /**
   * @generated from field: repeated string aliases = 5;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: string named_by_modification_id = 6;
   */ _define_property(this, "namedByModificationId", ""), /**
   * @generated from field: string owner_contact_id = 7;
   */ _define_property(this, "ownerContactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkstreamRequest, "runtime", proto3);
_define_property(CreateWorkstreamRequest, "typeName", "mono.datagateway.v1.CreateWorkstreamRequest");
_define_property(CreateWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "named_by_modification_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateWorkstreamResponse
 */ export class CreateWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstream workstream = 1;
   */ _define_property(this, "workstream", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateWorkstreamResponse, "runtime", proto3);
_define_property(CreateWorkstreamResponse, "typeName", "mono.datagateway.v1.CreateWorkstreamResponse");
_define_property(CreateWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream",
            kind: "message",
            T: ContractWorkstream
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateWorkstreamRequest: a 1:1 continuation under a new name is a rename of
 * the same workstream, never a lineage edge.
 *
 * @generated from message mono.datagateway.v1.UpdateWorkstreamRequest
 */ export class UpdateWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: optional string name = 5;
   */ _define_property(this, "name", void 0), /**
   * replace_aliases: aliases replaces the set (an empty set clears it).
   *
   * @generated from field: bool replace_aliases = 6;
   */ _define_property(this, "replaceAliases", false), /**
   * @generated from field: repeated string aliases = 7;
   */ _define_property(this, "aliases", []), /**
   * @generated from field: optional string owner_contact_id = 8;
   */ _define_property(this, "ownerContactId", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamRequest, "runtime", proto3);
_define_property(UpdateWorkstreamRequest, "typeName", "mono.datagateway.v1.UpdateWorkstreamRequest");
_define_property(UpdateWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "replace_aliases",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "aliases",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "owner_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateWorkstreamResponse
 */ export class UpdateWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstream workstream = 1;
   */ _define_property(this, "workstream", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateWorkstreamResponse, "runtime", proto3);
_define_property(UpdateWorkstreamResponse, "typeName", "mono.datagateway.v1.UpdateWorkstreamResponse");
_define_property(UpdateWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream",
            kind: "message",
            T: ContractWorkstream
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkstreamRequest
 */ export class GetWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: string workstream_id = 3;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamRequest, "runtime", proto3);
_define_property(GetWorkstreamRequest, "typeName", "mono.datagateway.v1.GetWorkstreamRequest");
_define_property(GetWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWorkstreamResponse
 */ export class GetWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstream workstream = 1;
   */ _define_property(this, "workstream", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSow sows = 2;
   */ _define_property(this, "sows", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractWorkstreamLineage predecessors = 3;
   */ _define_property(this, "predecessors", []), /**
   * @generated from field: repeated mono.datagateway.v1.ContractWorkstreamLineage successors = 4;
   */ _define_property(this, "successors", []), /**
   * @generated from field: repeated mono.datagateway.v1.SowGapRuling gap_rulings = 5;
   */ _define_property(this, "gapRulings", []), /**
   * current_window is the D104 window on as_of (basis "none" when there is none).
   *
   * @generated from field: mono.datagateway.v1.ResolvedWindow current_window = 6;
   */ _define_property(this, "currentWindow", void 0), /**
   * open_gaps are the workstream's SOW_HISTORY_MISSING windows not yet ruled.
   *
   * @generated from field: repeated mono.datagateway.v1.DutyCheck open_gaps = 7;
   */ _define_property(this, "openGaps", []), /**
   * exercise_lines are the exercise lines that authorize this workstream.
   *
   * @generated from field: repeated mono.datagateway.v1.ExerciseLine exercise_lines = 8;
   */ _define_property(this, "exerciseLines", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWorkstreamResponse, "runtime", proto3);
_define_property(GetWorkstreamResponse, "typeName", "mono.datagateway.v1.GetWorkstreamResponse");
_define_property(GetWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream",
            kind: "message",
            T: ContractWorkstream
        },
        {
            no: 2,
            name: "sows",
            kind: "message",
            T: ContractSow,
            repeated: true
        },
        {
            no: 3,
            name: "predecessors",
            kind: "message",
            T: ContractWorkstreamLineage,
            repeated: true
        },
        {
            no: 4,
            name: "successors",
            kind: "message",
            T: ContractWorkstreamLineage,
            repeated: true
        },
        {
            no: 5,
            name: "gap_rulings",
            kind: "message",
            T: SowGapRuling,
            repeated: true
        },
        {
            no: 6,
            name: "current_window",
            kind: "message",
            T: ResolvedWindow
        },
        {
            no: 7,
            name: "open_gaps",
            kind: "message",
            T: DutyCheck,
            repeated: true
        },
        {
            no: 8,
            name: "exercise_lines",
            kind: "message",
            T: ExerciseLine,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamsRequest
 */ export class ListWorkstreamsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamsRequest, "runtime", proto3);
_define_property(ListWorkstreamsRequest, "typeName", "mono.datagateway.v1.ListWorkstreamsRequest");
_define_property(ListWorkstreamsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWorkstreamsResponse
 */ export class ListWorkstreamsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWorkstreamsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWorkstreamsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWorkstreamsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWorkstreamsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractWorkstream workstreams = 1;
   */ _define_property(this, "workstreams", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWorkstreamsResponse, "runtime", proto3);
_define_property(ListWorkstreamsResponse, "typeName", "mono.datagateway.v1.ListWorkstreamsResponse");
_define_property(ListWorkstreamsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstreams",
            kind: "message",
            T: ContractWorkstream,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkWorkstreamLineageRequest
 */ export class LinkWorkstreamLineageRequest extends Message {
    static fromBinary(bytes, options) {
        return new LinkWorkstreamLineageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkWorkstreamLineageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkWorkstreamLineageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkWorkstreamLineageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string predecessor_workstream_id = 4;
   */ _define_property(this, "predecessorWorkstreamId", ""), /**
   * @generated from field: string successor_workstream_id = 5;
   */ _define_property(this, "successorWorkstreamId", ""), /**
   * @generated from field: string effective_on = 6;
   */ _define_property(this, "effectiveOn", ""), /**
   * @generated from field: string source_document_id = 7;
   */ _define_property(this, "sourceDocumentId", ""), /**
   * @generated from field: string source_locator = 8;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkWorkstreamLineageRequest, "runtime", proto3);
_define_property(LinkWorkstreamLineageRequest, "typeName", "mono.datagateway.v1.LinkWorkstreamLineageRequest");
_define_property(LinkWorkstreamLineageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "predecessor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "successor_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "effective_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.LinkWorkstreamLineageResponse
 */ export class LinkWorkstreamLineageResponse extends Message {
    static fromBinary(bytes, options) {
        return new LinkWorkstreamLineageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LinkWorkstreamLineageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LinkWorkstreamLineageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LinkWorkstreamLineageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractWorkstreamLineage lineage = 1;
   */ _define_property(this, "lineage", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LinkWorkstreamLineageResponse, "runtime", proto3);
_define_property(LinkWorkstreamLineageResponse, "typeName", "mono.datagateway.v1.LinkWorkstreamLineageResponse");
_define_property(LinkWorkstreamLineageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lineage",
            kind: "message",
            T: ContractWorkstreamLineage
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSowRequest
 */ export class CreateSowRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSowRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSowRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSowRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSowRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string version = 6;
   */ _define_property(this, "version", ""), /**
   * @generated from field: string approved_on = 7;
   */ _define_property(this, "approvedOn", ""), /**
   * @generated from field: string pop_start = 8;
   */ _define_property(this, "popStart", ""), /**
   * @generated from field: string pop_end = 9;
   */ _define_property(this, "popEnd", ""), /**
   * @generated from field: string program_document_id = 10;
   */ _define_property(this, "programDocumentId", ""), /**
   * not_held: a version named in a held SOW's history but not held itself
   * (D104); requires named_in_sow_id and named_in_locator.
   *
   * @generated from field: bool not_held = 11;
   */ _define_property(this, "notHeld", false), /**
   * @generated from field: string named_in_sow_id = 12;
   */ _define_property(this, "namedInSowId", ""), /**
   * @generated from field: string named_in_locator = 13;
   */ _define_property(this, "namedInLocator", ""), /**
   * @generated from field: string named_in_quote = 14;
   */ _define_property(this, "namedInQuote", ""), /**
   * @generated from field: string supersedes_sow_id = 15;
   */ _define_property(this, "supersedesSowId", ""), /**
   * @generated from field: string as_of = 16;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSowRequest, "runtime", proto3);
_define_property(CreateSowRequest, "typeName", "mono.datagateway.v1.CreateSowRequest");
_define_property(CreateSowRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "approved_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pop_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "pop_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "program_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "not_held",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "named_in_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "named_in_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "named_in_quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "supersedes_sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSowResponse
 */ export class CreateSowResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSowResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSowResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSowResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSowResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSow sow = 1;
   */ _define_property(this, "sow", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSowResponse, "runtime", proto3);
_define_property(CreateSowResponse, "typeName", "mono.datagateway.v1.CreateSowResponse");
_define_property(CreateSowResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sow",
            kind: "message",
            T: ContractSow
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * ExerciseLine is one exercise line (SLIN) and the workstreams it authorizes.
 *
 * @generated from message mono.datagateway.v1.ExerciseLine
 */ export class ExerciseLine extends Message {
    static fromBinary(bytes, options) {
        return new ExerciseLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExerciseLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExerciseLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExerciseLine, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string slin_id = 1;
   */ _define_property(this, "slinId", ""), /**
   * @generated from field: string exercise_id = 2;
   */ _define_property(this, "exerciseId", ""), /**
   * @generated from field: string optional_task_id = 3;
   */ _define_property(this, "optionalTaskId", ""), /**
   * @generated from field: string clin_number = 4;
   */ _define_property(this, "clinNumber", ""), /**
   * @generated from field: string pop_start = 5;
   */ _define_property(this, "popStart", ""), /**
   * @generated from field: string pop_end = 6;
   */ _define_property(this, "popEnd", ""), /**
   * @generated from field: repeated mono.datagateway.v1.ExerciseLineWorkstream workstreams = 7;
   */ _define_property(this, "workstreams", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExerciseLine, "runtime", proto3);
_define_property(ExerciseLine, "typeName", "mono.datagateway.v1.ExerciseLine");
_define_property(ExerciseLine, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "slin_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "optional_task_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "pop_start",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pop_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "workstreams",
            kind: "message",
            T: ExerciseLineWorkstream,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ExerciseLineWorkstream
 */ export class ExerciseLineWorkstream extends Message {
    static fromBinary(bytes, options) {
        return new ExerciseLineWorkstream().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExerciseLineWorkstream().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExerciseLineWorkstream().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExerciseLineWorkstream, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string workstream_id = 1;
   */ _define_property(this, "workstreamId", ""), /**
   * sow_id is the SOW/EP the line's title cites; "" = none.
   *
   * @generated from field: string sow_id = 2;
   */ _define_property(this, "sowId", ""), /**
   * basis: stated (the document says so) | reviewer.
   *
   * @generated from field: string basis = 3;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string source_locator = 4;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExerciseLineWorkstream, "runtime", proto3);
_define_property(ExerciseLineWorkstream, "typeName", "mono.datagateway.v1.ExerciseLineWorkstream");
_define_property(ExerciseLineWorkstream, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetExerciseWorkstreamRequest
 */ export class SetExerciseWorkstreamRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetExerciseWorkstreamRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetExerciseWorkstreamRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetExerciseWorkstreamRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetExerciseWorkstreamRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string exercise_id = 3;
   */ _define_property(this, "exerciseId", ""), /**
   * workstream_ids is the line's whole reviewer set: reviewer links left out
   * are removed. Links the document states are kept either way.
   *
   * @generated from field: repeated string workstream_ids = 4;
   */ _define_property(this, "workstreamIds", []), /**
   * clin_number names the exercise's line. "" = its only line, or, when it
   * has none, the exercise's own CLIN number (the line is then written).
   *
   * @generated from field: string clin_number = 5;
   */ _define_property(this, "clinNumber", ""), /**
   * sow_id: the SOW/EP the line cites; only with one workstream.
   *
   * @generated from field: string sow_id = 6;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string source_locator = 7;
   */ _define_property(this, "sourceLocator", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetExerciseWorkstreamRequest, "runtime", proto3);
_define_property(SetExerciseWorkstreamRequest, "typeName", "mono.datagateway.v1.SetExerciseWorkstreamRequest");
_define_property(SetExerciseWorkstreamRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "exercise_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "workstream_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "clin_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetExerciseWorkstreamResponse
 */ export class SetExerciseWorkstreamResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetExerciseWorkstreamResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetExerciseWorkstreamResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetExerciseWorkstreamResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetExerciseWorkstreamResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ExerciseLine line = 1;
   */ _define_property(this, "line", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetExerciseWorkstreamResponse, "runtime", proto3);
_define_property(SetExerciseWorkstreamResponse, "typeName", "mono.datagateway.v1.SetExerciseWorkstreamResponse");
_define_property(SetExerciseWorkstreamResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "line",
            kind: "message",
            T: ExerciseLine
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * TeamRule is one rule of an assignment. id set: update that rule in place.
 *
 * @generated from message mono.datagateway.v1.TeamRule
 */ export class TeamRule extends Message {
    static fromBinary(bytes, options) {
        return new TeamRule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TeamRule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TeamRule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TeamRule, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.ScheduleRuleFields fields = 2;
   */ _define_property(this, "fields", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(TeamRule, "runtime", proto3);
_define_property(TeamRule, "typeName", "mono.datagateway.v1.TeamRule");
_define_property(TeamRule, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "fields",
            kind: "message",
            T: ScheduleRuleFields
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetDutyAssignmentRequest
 */ export class SetDutyAssignmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetDutyAssignmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDutyAssignmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDutyAssignmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDutyAssignmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string sow_id = 4;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string duty_id = 5;
   */ _define_property(this, "dutyId", ""), /**
   * handling: performed | routed | not_owed.
   *
   * @generated from field: string handling = 6;
   */ _define_property(this, "handling", ""), /**
   * routed_to_workstream_id "" with routed = base scope / contract-wide.
   *
   * @generated from field: string routed_to_workstream_id = 7;
   */ _define_property(this, "routedToWorkstreamId", ""), /**
   * not_owed_reason: waived | not_applicable | duplicate | not_listed.
   *
   * @generated from field: string not_owed_reason = 8;
   */ _define_property(this, "notOwedReason", ""), /**
   * @generated from field: string title_as_stated = 9;
   */ _define_property(this, "titleAsStated", ""), /**
   * @generated from field: string sender_contact_id = 10;
   */ _define_property(this, "senderContactId", ""), /**
   * @generated from field: string recipient = 11;
   */ _define_property(this, "recipient", ""), /**
   * @generated from field: string format = 12;
   */ _define_property(this, "format", ""), /**
   * @generated from field: string submission_method = 13;
   */ _define_property(this, "submissionMethod", ""), /**
   * @generated from field: string acceptance_criteria = 14;
   */ _define_property(this, "acceptanceCriteria", ""), /**
   * override_locators: one per set override (field as override_locators stores it).
   *
   * @generated from field: repeated mono.datagateway.v1.OverrideLocator override_locators = 15;
   */ _define_property(this, "overrideLocators", []), /**
   * @generated from field: string source_locator = 16;
   */ _define_property(this, "sourceLocator", ""), /**
   * @generated from field: string note = 17;
   */ _define_property(this, "note", ""), /**
   * team_rules is the whole set: rules left out are removed. Only with
   * handling "performed". Each rule's gate is "sow".
   *
   * @generated from field: repeated mono.datagateway.v1.TeamRule team_rules = 18;
   */ _define_property(this, "teamRules", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDutyAssignmentRequest, "runtime", proto3);
_define_property(SetDutyAssignmentRequest, "typeName", "mono.datagateway.v1.SetDutyAssignmentRequest");
_define_property(SetDutyAssignmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "duty_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "handling",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "routed_to_workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "not_owed_reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "title_as_stated",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sender_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "recipient",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "submission_method",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "acceptance_criteria",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "override_locators",
            kind: "message",
            T: OverrideLocator,
            repeated: true
        },
        {
            no: 16,
            name: "source_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 18,
            name: "team_rules",
            kind: "message",
            T: TeamRule,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetDutyAssignmentResponse
 */ export class SetDutyAssignmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetDutyAssignmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetDutyAssignmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetDutyAssignmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetDutyAssignmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractDutyAssignment assignment = 1;
   */ _define_property(this, "assignment", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetDutyAssignmentResponse, "runtime", proto3);
_define_property(SetDutyAssignmentResponse, "typeName", "mono.datagateway.v1.SetDutyAssignmentResponse");
_define_property(SetDutyAssignmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assignment",
            kind: "message",
            T: ContractDutyAssignment
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RuleSowGapRequest
 */ export class RuleSowGapRequest extends Message {
    static fromBinary(bytes, options) {
        return new RuleSowGapRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleSowGapRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleSowGapRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleSowGapRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string workstream_id = 4;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: string from_on = 5;
   */ _define_property(this, "fromOn", ""), /**
   * @generated from field: string to_on = 6;
   */ _define_property(this, "toOn", ""), /**
   * @generated from field: mono.datagateway.v1.SowGapChoice choice = 7;
   */ _define_property(this, "choice", 0), /**
   * @generated from field: string sow_id = 8;
   */ _define_property(this, "sowId", ""), /**
   * @generated from field: string change_item_id = 9;
   */ _define_property(this, "changeItemId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RuleSowGapRequest, "runtime", proto3);
_define_property(RuleSowGapRequest, "typeName", "mono.datagateway.v1.RuleSowGapRequest");
_define_property(RuleSowGapRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "from_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "to_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "choice",
            kind: "enum",
            T: proto3.getEnumType(SowGapChoice)
        },
        {
            no: 8,
            name: "sow_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "change_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RuleSowGapResponse
 */ export class RuleSowGapResponse extends Message {
    static fromBinary(bytes, options) {
        return new RuleSowGapResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleSowGapResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleSowGapResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleSowGapResponse, a, b);
    }
    constructor(data){
        super(), /**
   * ruling is unset for UPLOAD_EARLIER.
   *
   * @generated from field: mono.datagateway.v1.SowGapRuling ruling = 1;
   */ _define_property(this, "ruling", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0), /**
   * open_gaps are the workstream's SOW_HISTORY_MISSING windows still unruled
   * after this call.
   *
   * @generated from field: repeated mono.datagateway.v1.DutyCheck open_gaps = 3;
   */ _define_property(this, "openGaps", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RuleSowGapResponse, "runtime", proto3);
_define_property(RuleSowGapResponse, "typeName", "mono.datagateway.v1.RuleSowGapResponse");
_define_property(RuleSowGapResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "ruling",
            kind: "message",
            T: SowGapRuling
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        },
        {
            no: 3,
            name: "open_gaps",
            kind: "message",
            T: DutyCheck,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SubmissionAttachmentInput
 */ export class SubmissionAttachmentInput extends Message {
    static fromBinary(bytes, options) {
        return new SubmissionAttachmentInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmissionAttachmentInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmissionAttachmentInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmissionAttachmentInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string artifact_id = 1;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: string url = 2;
   */ _define_property(this, "url", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmissionAttachmentInput, "runtime", proto3);
_define_property(SubmissionAttachmentInput, "typeName", "mono.datagateway.v1.SubmissionAttachmentInput");
_define_property(SubmissionAttachmentInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "url",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSubmissionRequest
 */ export class CreateSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string occurrence_id = 4;
   */ _define_property(this, "occurrenceId", ""), /**
   * also_occurrence_ids: the same package also counts for these (siblings).
   *
   * @generated from field: repeated string also_occurrence_ids = 5;
   */ _define_property(this, "alsoOccurrenceIds", []), /**
   * @generated from field: string submitted_on = 6;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_at = 7;
   */ _define_property(this, "submittedAt", ""), /**
   * @generated from field: string submitted_by_contact_id = 8;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 9;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 10;
   */ _define_property(this, "sentToContactIds", []), /**
   * @generated from field: string note = 11;
   */ _define_property(this, "note", ""), /**
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 12;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubmissionRequest, "runtime", proto3);
_define_property(CreateSubmissionRequest, "typeName", "mono.datagateway.v1.CreateSubmissionRequest");
_define_property(CreateSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "occurrence_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "also_occurrence_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateSubmissionResponse
 */ export class CreateSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.ContractSubmission submissions = 1;
   */ _define_property(this, "submissions", []), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateSubmissionResponse, "runtime", proto3);
_define_property(CreateSubmissionResponse, "typeName", "mono.datagateway.v1.CreateSubmissionResponse");
_define_property(CreateSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submissions",
            kind: "message",
            T: ContractSubmission,
            repeated: true
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * UpdateSubmissionRequest replaces the submission's stated fields;
 * attachments are replaced only when replace_attachments is set.
 *
 * @generated from message mono.datagateway.v1.UpdateSubmissionRequest
 */ export class UpdateSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string submitted_on = 5;
   */ _define_property(this, "submittedOn", ""), /**
   * @generated from field: string submitted_at = 6;
   */ _define_property(this, "submittedAt", ""), /**
   * @generated from field: string submitted_by_contact_id = 7;
   */ _define_property(this, "submittedByContactId", ""), /**
   * @generated from field: string submitted_by_display = 8;
   */ _define_property(this, "submittedByDisplay", ""), /**
   * @generated from field: repeated string sent_to_contact_ids = 9;
   */ _define_property(this, "sentToContactIds", []), /**
   * @generated from field: string note = 10;
   */ _define_property(this, "note", ""), /**
   * @generated from field: bool replace_attachments = 11;
   */ _define_property(this, "replaceAttachments", false), /**
   * @generated from field: repeated mono.datagateway.v1.SubmissionAttachmentInput attachments = 12;
   */ _define_property(this, "attachments", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubmissionRequest, "runtime", proto3);
_define_property(UpdateSubmissionRequest, "typeName", "mono.datagateway.v1.UpdateSubmissionRequest");
_define_property(UpdateSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "submitted_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "submitted_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "submitted_by_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "submitted_by_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "sent_to_contact_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 10,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "replace_attachments",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 12,
            name: "attachments",
            kind: "message",
            T: SubmissionAttachmentInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateSubmissionResponse
 */ export class UpdateSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSubmission submission = 1;
   */ _define_property(this, "submission", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateSubmissionResponse, "runtime", proto3);
_define_property(UpdateSubmissionResponse, "typeName", "mono.datagateway.v1.UpdateSubmissionResponse");
_define_property(UpdateSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ContractSubmission
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WithdrawSubmissionRequest
 */ export class WithdrawSubmissionRequest extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawSubmissionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawSubmissionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawSubmissionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawSubmissionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawSubmissionRequest, "runtime", proto3);
_define_property(WithdrawSubmissionRequest, "typeName", "mono.datagateway.v1.WithdrawSubmissionRequest");
_define_property(WithdrawSubmissionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WithdrawSubmissionResponse
 */ export class WithdrawSubmissionResponse extends Message {
    static fromBinary(bytes, options) {
        return new WithdrawSubmissionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WithdrawSubmissionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WithdrawSubmissionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WithdrawSubmissionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSubmission submission = 1;
   */ _define_property(this, "submission", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WithdrawSubmissionResponse, "runtime", proto3);
_define_property(WithdrawSubmissionResponse, "typeName", "mono.datagateway.v1.WithdrawSubmissionResponse");
_define_property(WithdrawSubmissionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "submission",
            kind: "message",
            T: ContractSubmission
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordReviewRequest
 */ export class RecordReviewRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordReviewRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordReviewRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordReviewRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordReviewRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string submission_id = 4;
   */ _define_property(this, "submissionId", ""), /**
   * @generated from field: string tier = 5;
   */ _define_property(this, "tier", ""), /**
   * @generated from field: string decision = 6;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string reviewer_contact_id = 7;
   */ _define_property(this, "reviewerContactId", ""), /**
   * @generated from field: string reviewer_display = 8;
   */ _define_property(this, "reviewerDisplay", ""), /**
   * @generated from field: string decided_on = 9;
   */ _define_property(this, "decidedOn", ""), /**
   * @generated from field: string notes = 10;
   */ _define_property(this, "notes", ""), /**
   * @generated from field: string evidence_artifact_id = 11;
   */ _define_property(this, "evidenceArtifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordReviewRequest, "runtime", proto3);
_define_property(RecordReviewRequest, "typeName", "mono.datagateway.v1.RecordReviewRequest");
_define_property(RecordReviewRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "submission_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tier",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reviewer_contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reviewer_display",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "decided_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "notes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "evidence_artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordReviewResponse
 */ export class RecordReviewResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordReviewResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordReviewResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordReviewResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordReviewResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSubmissionReview review = 1;
   */ _define_property(this, "review", void 0), /**
   * converged: the review restated the live one and nothing was written.
   *
   * @generated from field: bool converged = 2;
   */ _define_property(this, "converged", false), /**
   * @generated from field: string superseded_review_id = 3;
   */ _define_property(this, "supersededReviewId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 4;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordReviewResponse, "runtime", proto3);
_define_property(RecordReviewResponse, "typeName", "mono.datagateway.v1.RecordReviewResponse");
_define_property(RecordReviewResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review",
            kind: "message",
            T: ContractSubmissionReview
        },
        {
            no: 2,
            name: "converged",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "superseded_review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ImportTrackerRequest
 */ export class ImportTrackerRequest extends Message {
    static fromBinary(bytes, options) {
        return new ImportTrackerRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportTrackerRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportTrackerRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportTrackerRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: bool dry_run = 5;
   */ _define_property(this, "dryRun", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportTrackerRequest, "runtime", proto3);
_define_property(ImportTrackerRequest, "typeName", "mono.datagateway.v1.ImportTrackerRequest");
_define_property(ImportTrackerRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "dry_run",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ImportTrackerResponse
 */ export class ImportTrackerResponse extends Message {
    static fromBinary(bytes, options) {
        return new ImportTrackerResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImportTrackerResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImportTrackerResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImportTrackerResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ImportTrackerResponse, "runtime", proto3);
_define_property(ImportTrackerResponse, "typeName", "mono.datagateway.v1.ImportTrackerResponse");
_define_property(ImportTrackerResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.DeliverableSettings
 */ export class DeliverableSettings extends Message {
    static fromBinary(bytes, options) {
        return new DeliverableSettings().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeliverableSettings().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeliverableSettings().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeliverableSettings, a, b);
    }
    constructor(data){
        super(), /**
   * roll: following_federal_workday | preceding_federal_workday | none;
   * "" = the contract does not state it (never assumed, D86).
   *
   * @generated from field: string roll = 1;
   */ _define_property(this, "roll", ""), /**
   * @generated from field: string roll_locator = 2;
   */ _define_property(this, "rollLocator", ""), /**
   * @generated from field: repeated string recipients = 3;
   */ _define_property(this, "recipients", []), /**
   * higher_tier_satisfies (D110): an approval at a VA tier above the duty's
   * final tier also approves. Default false (strict).
   *
   * @generated from field: bool higher_tier_satisfies = 4;
   */ _define_property(this, "higherTierSatisfies", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DeliverableSettings, "runtime", proto3);
_define_property(DeliverableSettings, "typeName", "mono.datagateway.v1.DeliverableSettings");
_define_property(DeliverableSettings, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "roll",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "roll_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "recipients",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "higher_tier_satisfies",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeliverableSettingsRequest
 */ export class GetDeliverableSettingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableSettingsRequest, "runtime", proto3);
_define_property(GetDeliverableSettingsRequest, "typeName", "mono.datagateway.v1.GetDeliverableSettingsRequest");
_define_property(GetDeliverableSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetDeliverableSettingsResponse
 */ export class GetDeliverableSettingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetDeliverableSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetDeliverableSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetDeliverableSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetDeliverableSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableSettings settings = 1;
   */ _define_property(this, "settings", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetDeliverableSettingsResponse, "runtime", proto3);
_define_property(GetDeliverableSettingsResponse, "typeName", "mono.datagateway.v1.GetDeliverableSettingsResponse");
_define_property(GetDeliverableSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "settings",
            kind: "message",
            T: DeliverableSettings
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDeliverableSettingsRequest
 */ export class UpdateDeliverableSettingsRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableSettingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableSettingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableSettingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableSettingsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * Each field is written only when present.
   *
   * @generated from field: optional string roll = 4;
   */ _define_property(this, "roll", void 0), /**
   * @generated from field: optional string roll_locator = 5;
   */ _define_property(this, "rollLocator", void 0), /**
   * @generated from field: bool replace_recipients = 6;
   */ _define_property(this, "replaceRecipients", false), /**
   * @generated from field: repeated string recipients = 7;
   */ _define_property(this, "recipients", []), /**
   * @generated from field: optional bool higher_tier_satisfies = 8;
   */ _define_property(this, "higherTierSatisfies", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableSettingsRequest, "runtime", proto3);
_define_property(UpdateDeliverableSettingsRequest, "typeName", "mono.datagateway.v1.UpdateDeliverableSettingsRequest");
_define_property(UpdateDeliverableSettingsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "roll",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 5,
            name: "roll_locator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 6,
            name: "replace_recipients",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "recipients",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "higher_tier_satisfies",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ ,
            opt: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpdateDeliverableSettingsResponse
 */ export class UpdateDeliverableSettingsResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpdateDeliverableSettingsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateDeliverableSettingsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateDeliverableSettingsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateDeliverableSettingsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.DeliverableSettings settings = 1;
   */ _define_property(this, "settings", void 0), /**
   * @generated from field: mono.datagateway.v1.WriteResult result = 2;
   */ _define_property(this, "result", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpdateDeliverableSettingsResponse, "runtime", proto3);
_define_property(UpdateDeliverableSettingsResponse, "typeName", "mono.datagateway.v1.UpdateDeliverableSettingsResponse");
_define_property(UpdateDeliverableSettingsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "settings",
            kind: "message",
            T: DeliverableSettings
        },
        {
            no: 2,
            name: "result",
            kind: "message",
            T: WriteResult
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryRef
 */ export class GlossaryRef extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 page = 1;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string quote = 2;
   */ _define_property(this, "quote", ""), /**
   * @generated from field: string document_id = 3;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_key = 4;
   */ _define_property(this, "sectionKey", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryRef, "runtime", proto3);
_define_property(GlossaryRef, "typeName", "mono.datagateway.v1.GlossaryRef");
_define_property(GlossaryRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "quote",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryTerm
 */ export class GlossaryTerm extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryTerm().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryTerm().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryTerm().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryTerm, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string term = 2;
   */ _define_property(this, "term", ""), /**
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string expansion = 4;
   */ _define_property(this, "expansion", ""), /**
   * @generated from field: string workstream_id = 5;
   */ _define_property(this, "workstreamId", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 6;
   */ _define_property(this, "refs", []), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryTerm, "runtime", proto3);
_define_property(GlossaryTerm, "typeName", "mono.datagateway.v1.GlossaryTerm");
_define_property(GlossaryTerm, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "term",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "expansion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryRelation
 */ export class GlossaryRelation extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryRelation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryRelation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryRelation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryRelation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string from_term_id = 2;
   */ _define_property(this, "fromTermId", ""), /**
   * @generated from field: string to_term_id = 3;
   */ _define_property(this, "toTermId", ""), /**
   * @generated from field: string relation = 4;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: string reason = 5;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 6;
   */ _define_property(this, "refs", []), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * @generated from field: string status = 8;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryRelation, "runtime", proto3);
_define_property(GlossaryRelation, "typeName", "mono.datagateway.v1.GlossaryRelation");
_define_property(GlossaryRelation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "from_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "to_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossarySectionHealth
 */ export class GlossarySectionHealth extends Message {
    static fromBinary(bytes, options) {
        return new GlossarySectionHealth().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossarySectionHealth().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossarySectionHealth().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossarySectionHealth, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int32 verified = 1;
   */ _define_property(this, "verified", 0), /**
   * @generated from field: int32 failed = 2;
   */ _define_property(this, "failed", 0), /**
   * @generated from field: int32 total = 3;
   */ _define_property(this, "total", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossarySectionHealth, "runtime", proto3);
_define_property(GlossarySectionHealth, "typeName", "mono.datagateway.v1.GlossarySectionHealth");
_define_property(GlossarySectionHealth, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "verified",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "failed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "total",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryTermInput
 */ export class GlossaryTermInput extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryTermInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryTermInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryTermInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryTermInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string term = 1;
   */ _define_property(this, "term", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string expansion = 3;
   */ _define_property(this, "expansion", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 4;
   */ _define_property(this, "refs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryTermInput, "runtime", proto3);
_define_property(GlossaryTermInput, "typeName", "mono.datagateway.v1.GlossaryTermInput");
_define_property(GlossaryTermInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "term",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expansion",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GlossaryRelationInput
 */ export class GlossaryRelationInput extends Message {
    static fromBinary(bytes, options) {
        return new GlossaryRelationInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GlossaryRelationInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GlossaryRelationInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GlossaryRelationInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string from = 1;
   */ _define_property(this, "from", ""), /**
   * @generated from field: string to = 2;
   */ _define_property(this, "to", ""), /**
   * @generated from field: string relation = 3;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRef refs = 4;
   */ _define_property(this, "refs", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GlossaryRelationInput, "runtime", proto3);
_define_property(GlossaryRelationInput, "typeName", "mono.datagateway.v1.GlossaryRelationInput");
_define_property(GlossaryRelationInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "from",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "to",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "refs",
            kind: "message",
            T: GlossaryRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertGlossarySectionRequest
 */ export class UpsertGlossarySectionRequest extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGlossarySectionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGlossarySectionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGlossarySectionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGlossarySectionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string document_id = 4;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string section_key = 5;
   */ _define_property(this, "sectionKey", ""), /**
   * @generated from field: string section_number = 6;
   */ _define_property(this, "sectionNumber", ""), /**
   * @generated from field: string heading = 7;
   */ _define_property(this, "heading", ""), /**
   * @generated from field: string content_sha256 = 8;
   */ _define_property(this, "contentSha256", ""), /**
   * @generated from field: string prompt_version = 9;
   */ _define_property(this, "promptVersion", ""), /**
   * @generated from field: string model = 10;
   */ _define_property(this, "model", ""), /**
   * status: verified | failed
   *
   * @generated from field: string status = 11;
   */ _define_property(this, "status", ""), /**
   * @generated from field: int32 proposed = 12;
   */ _define_property(this, "proposed", 0), /**
   * @generated from field: int32 kept = 13;
   */ _define_property(this, "kept", 0), /**
   * @generated from field: int32 dropped = 14;
   */ _define_property(this, "dropped", 0), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryTermInput terms = 15;
   */ _define_property(this, "terms", []), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRelationInput relations = 16;
   */ _define_property(this, "relations", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGlossarySectionRequest, "runtime", proto3);
_define_property(UpsertGlossarySectionRequest, "typeName", "mono.datagateway.v1.UpsertGlossarySectionRequest");
_define_property(UpsertGlossarySectionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "section_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "section_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "heading",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "content_sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "prompt_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "model",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "proposed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "kept",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "dropped",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 15,
            name: "terms",
            kind: "message",
            T: GlossaryTermInput,
            repeated: true
        },
        {
            no: 16,
            name: "relations",
            kind: "message",
            T: GlossaryRelationInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.UpsertGlossarySectionResponse
 */ export class UpsertGlossarySectionResponse extends Message {
    static fromBinary(bytes, options) {
        return new UpsertGlossarySectionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpsertGlossarySectionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpsertGlossarySectionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpsertGlossarySectionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string section_id = 1;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: bool cache_hit = 2;
   */ _define_property(this, "cacheHit", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UpsertGlossarySectionResponse, "runtime", proto3);
_define_property(UpsertGlossarySectionResponse, "typeName", "mono.datagateway.v1.UpsertGlossarySectionResponse");
_define_property(UpsertGlossarySectionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "cache_hit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramGlossaryRequest
 */ export class GetProgramGlossaryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramGlossaryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramGlossaryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramGlossaryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramGlossaryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramGlossaryRequest, "runtime", proto3);
_define_property(GetProgramGlossaryRequest, "typeName", "mono.datagateway.v1.GetProgramGlossaryRequest");
_define_property(GetProgramGlossaryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetProgramGlossaryResponse
 */ export class GetProgramGlossaryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetProgramGlossaryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetProgramGlossaryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetProgramGlossaryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetProgramGlossaryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryTerm terms = 1;
   */ _define_property(this, "terms", []), /**
   * @generated from field: repeated mono.datagateway.v1.GlossaryRelation relations = 2;
   */ _define_property(this, "relations", []), /**
   * @generated from field: repeated string background = 3;
   */ _define_property(this, "background", []), /**
   * @generated from field: repeated string hosting = 4;
   */ _define_property(this, "hosting", []), /**
   * @generated from field: mono.datagateway.v1.GlossarySectionHealth sections = 5;
   */ _define_property(this, "sections", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetProgramGlossaryResponse, "runtime", proto3);
_define_property(GetProgramGlossaryResponse, "typeName", "mono.datagateway.v1.GetProgramGlossaryResponse");
_define_property(GetProgramGlossaryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "terms",
            kind: "message",
            T: GlossaryTerm,
            repeated: true
        },
        {
            no: 2,
            name: "relations",
            kind: "message",
            T: GlossaryRelation,
            repeated: true
        },
        {
            no: 3,
            name: "background",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "hosting",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "sections",
            kind: "message",
            T: GlossarySectionHealth
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RekindGlossaryTermRequest
 */ export class RekindGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new RekindGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RekindGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RekindGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RekindGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string term_id = 4;
   */ _define_property(this, "termId", ""), /**
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RekindGlossaryTermRequest, "runtime", proto3);
_define_property(RekindGlossaryTermRequest, "typeName", "mono.datagateway.v1.RekindGlossaryTermRequest");
_define_property(RekindGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RekindGlossaryTermResponse
 */ export class RekindGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new RekindGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RekindGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RekindGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RekindGlossaryTermResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GlossaryTerm term = 1;
   */ _define_property(this, "term", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RekindGlossaryTermResponse, "runtime", proto3);
_define_property(RekindGlossaryTermResponse, "typeName", "mono.datagateway.v1.RekindGlossaryTermResponse");
_define_property(RekindGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "term",
            kind: "message",
            T: GlossaryTerm
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryTermRequest
 */ export class RejectGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string term_id = 4;
   */ _define_property(this, "termId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryTermRequest, "runtime", proto3);
_define_property(RejectGlossaryTermRequest, "typeName", "mono.datagateway.v1.RejectGlossaryTermRequest");
_define_property(RejectGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryTermResponse
 */ export class RejectGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryTermResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryTermResponse, "runtime", proto3);
_define_property(RejectGlossaryTermResponse, "typeName", "mono.datagateway.v1.RejectGlossaryTermResponse");
_define_property(RejectGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryRelationRequest
 */ export class RejectGlossaryRelationRequest extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryRelationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryRelationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryRelationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryRelationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string relation_id = 4;
   */ _define_property(this, "relationId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryRelationRequest, "runtime", proto3);
_define_property(RejectGlossaryRelationRequest, "typeName", "mono.datagateway.v1.RejectGlossaryRelationRequest");
_define_property(RejectGlossaryRelationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "relation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RejectGlossaryRelationResponse
 */ export class RejectGlossaryRelationResponse extends Message {
    static fromBinary(bytes, options) {
        return new RejectGlossaryRelationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RejectGlossaryRelationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RejectGlossaryRelationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RejectGlossaryRelationResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(RejectGlossaryRelationResponse, "runtime", proto3);
_define_property(RejectGlossaryRelationResponse, "typeName", "mono.datagateway.v1.RejectGlossaryRelationResponse");
_define_property(RejectGlossaryRelationResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.datagateway.v1.AddGlossaryRelationRequest
 */ export class AddGlossaryRelationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddGlossaryRelationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddGlossaryRelationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddGlossaryRelationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddGlossaryRelationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string from_term_id = 4;
   */ _define_property(this, "fromTermId", ""), /**
   * @generated from field: string to_term_id = 5;
   */ _define_property(this, "toTermId", ""), /**
   * @generated from field: string relation = 6;
   */ _define_property(this, "relation", ""), /**
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddGlossaryRelationRequest, "runtime", proto3);
_define_property(AddGlossaryRelationRequest, "typeName", "mono.datagateway.v1.AddGlossaryRelationRequest");
_define_property(AddGlossaryRelationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "from_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "to_term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "relation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.AddGlossaryRelationResponse
 */ export class AddGlossaryRelationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddGlossaryRelationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddGlossaryRelationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddGlossaryRelationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddGlossaryRelationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GlossaryRelation relation = 1;
   */ _define_property(this, "relation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddGlossaryRelationResponse, "runtime", proto3);
_define_property(AddGlossaryRelationResponse, "typeName", "mono.datagateway.v1.AddGlossaryRelationResponse");
_define_property(AddGlossaryRelationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "relation",
            kind: "message",
            T: GlossaryRelation
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BindGlossaryTermRequest
 */ export class BindGlossaryTermRequest extends Message {
    static fromBinary(bytes, options) {
        return new BindGlossaryTermRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BindGlossaryTermRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BindGlossaryTermRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BindGlossaryTermRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 2;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 3;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: string term_id = 4;
   */ _define_property(this, "termId", ""), /**
   * @generated from field: string workstream_id = 5;
   */ _define_property(this, "workstreamId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(BindGlossaryTermRequest, "runtime", proto3);
_define_property(BindGlossaryTermRequest, "typeName", "mono.datagateway.v1.BindGlossaryTermRequest");
_define_property(BindGlossaryTermRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 2,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 4,
            name: "term_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "workstream_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.BindGlossaryTermResponse
 */ export class BindGlossaryTermResponse extends Message {
    static fromBinary(bytes, options) {
        return new BindGlossaryTermResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BindGlossaryTermResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BindGlossaryTermResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BindGlossaryTermResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.GlossaryTerm term = 1;
   */ _define_property(this, "term", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(BindGlossaryTermResponse, "runtime", proto3);
_define_property(BindGlossaryTermResponse, "typeName", "mono.datagateway.v1.BindGlossaryTermResponse");
_define_property(BindGlossaryTermResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "term",
            kind: "message",
            T: GlossaryTerm
        }
    ]));
/**
 * SowWorkProduct is a SOW's own commitment (origin sow) and its team rules.
 *
 * @generated from message mono.datagateway.v1.SowWorkProduct
 */ export class SowWorkProduct extends Message {
    static fromBinary(bytes, options) {
        return new SowWorkProduct().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SowWorkProduct().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SowWorkProduct().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SowWorkProduct, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.CreateDutyRequest duty = 1;
   */ _define_property(this, "duty", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.TeamRule team_rules = 2;
   */ _define_property(this, "teamRules", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SowWorkProduct, "runtime", proto3);
_define_property(SowWorkProduct, "typeName", "mono.datagateway.v1.SowWorkProduct");
_define_property(SowWorkProduct, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "duty",
            kind: "message",
            T: CreateDutyRequest
        },
        {
            no: 2,
            name: "team_rules",
            kind: "message",
            T: TeamRule,
            repeated: true
        }
    ]));
/**
 * IntakeSowRequest is a SOW/EP reading as writes. sow, assignments and
 * work products carry no program_id or sow_id: the request's program and
 * the SOW this call creates fill them.
 *
 * @generated from message mono.datagateway.v1.IntakeSowRequest
 */ export class IntakeSowRequest extends Message {
    static fromBinary(bytes, options) {
        return new IntakeSowRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntakeSowRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntakeSowRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntakeSowRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * @generated from field: mono.datagateway.v1.WriteContext write = 2;
   */ _define_property(this, "write", void 0), /**
   * @generated from field: mono.datagateway.v1.CreateSowRequest sow = 3;
   */ _define_property(this, "sow", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.SetDutyAssignmentRequest assignments = 4;
   */ _define_property(this, "assignments", []), /**
   * @generated from field: repeated mono.datagateway.v1.SowWorkProduct work_products = 5;
   */ _define_property(this, "workProducts", []), /**
   * Unsettled facts. target_locator is filled with the new SOW's id for a
   * DutyAssignment target.
   *
   * @generated from field: repeated mono.common.v1.ReviewItem review_items = 6;
   */ _define_property(this, "reviewItems", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntakeSowRequest, "runtime", proto3);
_define_property(IntakeSowRequest, "typeName", "mono.datagateway.v1.IntakeSowRequest");
_define_property(IntakeSowRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "write",
            kind: "message",
            T: WriteContext
        },
        {
            no: 3,
            name: "sow",
            kind: "message",
            T: CreateSowRequest
        },
        {
            no: 4,
            name: "assignments",
            kind: "message",
            T: SetDutyAssignmentRequest,
            repeated: true
        },
        {
            no: 5,
            name: "work_products",
            kind: "message",
            T: SowWorkProduct,
            repeated: true
        },
        {
            no: 6,
            name: "review_items",
            kind: "message",
            T: ReviewItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.IntakeSowResponse
 */ export class IntakeSowResponse extends Message {
    static fromBinary(bytes, options) {
        return new IntakeSowResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntakeSowResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntakeSowResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntakeSowResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.ContractSow sow = 1;
   */ _define_property(this, "sow", void 0), /**
   * @generated from field: int32 assignments = 2;
   */ _define_property(this, "assignments", 0), /**
   * @generated from field: int32 work_products = 3;
   */ _define_property(this, "workProducts", 0), /**
   * The ContractIntake set the review items were staged on ("" when none).
   *
   * @generated from field: string change_set_id = 4;
   */ _define_property(this, "changeSetId", ""), /**
   * @generated from field: int32 review_items = 5;
   */ _define_property(this, "reviewItems", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(IntakeSowResponse, "runtime", proto3);
_define_property(IntakeSowResponse, "typeName", "mono.datagateway.v1.IntakeSowResponse");
_define_property(IntakeSowResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "sow",
            kind: "message",
            T: ContractSow
        },
        {
            no: 2,
            name: "assignments",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "work_products",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "change_set_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "review_items",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
